!function(e){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{("undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this).EventEmitter3=e()}}(function(){return function i(s,f,c){function u(t,e){if(!f[t]){if(!s[t]){var n="function"==typeof require&&require;if(!e&&n)return n(t,!0);if(a)return a(t,!0);var r=new Error("Cannot find module '"+t+"'");throw r.code="MODULE_NOT_FOUND",r}var o=f[t]={exports:{}};s[t][0].call(o.exports,function(e){return u(s[t][1][e]||e)},o,o.exports,i,s,f,c)}return f[t].exports}for(var a="function"==typeof require&&require,e=0;e<c.length;e++)u(c[e]);return u}({1:[function(e,t,n){"use strict";var r=Object.prototype.hasOwnProperty,v="~";function o(){}function f(e,t,n){this.fn=e,this.context=t,this.once=n||!1}function i(e,t,n,r,o){if("function"!=typeof n)throw new TypeError("The listener must be a function");var i=new f(n,r||e,o),s=v?v+t:t;return e._events[s]?e._events[s].fn?e._events[s]=[e._events[s],i]:e._events[s].push(i):(e._events[s]=i,e._eventsCount++),e}function u(e,t){0==--e._eventsCount?e._events=new o:delete e._events[t]}function s(){this._events=new o,this._eventsCount=0}Object.create&&(o.prototype=Object.create(null),(new o).__proto__||(v=!1)),s.prototype.eventNames=function(){var e,t,n=[];if(0===this._eventsCount)return n;for(t in e=this._events)r.call(e,t)&&n.push(v?t.slice(1):t);return Object.getOwnPropertySymbols?n.concat(Object.getOwnPropertySymbols(e)):n},s.prototype.listeners=function(e){var t=v?v+e:e,n=this._events[t];if(!n)return[];if(n.fn)return[n.fn];for(var r=0,o=n.length,i=new Array(o);r<o;r++)i[r]=n[r].fn;return i},s.prototype.listenerCount=function(e){var t=v?v+e:e,n=this._events[t];return n?n.fn?1:n.length:0},s.prototype.emit=function(e,t,n,r,o,i){var s=v?v+e:e;if(!this._events[s])return!1;var f,c,u=this._events[s],a=arguments.length;if(u.fn){switch(u.once&&this.removeListener(e,u.fn,void 0,!0),a){case 1:return u.fn.call(u.context),!0;case 2:return u.fn.call(u.context,t),!0;case 3:return u.fn.call(u.context,t,n),!0;case 4:return u.fn.call(u.context,t,n,r),!0;case 5:return u.fn.call(u.context,t,n,r,o),!0;case 6:return u.fn.call(u.context,t,n,r,o,i),!0}for(c=1,f=new Array(a-1);c<a;c++)f[c-1]=arguments[c];u.fn.apply(u.context,f)}else{var l,p=u.length;for(c=0;c<p;c++)switch(u[c].once&&this.removeListener(e,u[c].fn,void 0,!0),a){case 1:u[c].fn.call(u[c].context);break;case 2:u[c].fn.call(u[c].context,t);break;case 3:u[c].fn.call(u[c].context,t,n);break;case 4:u[c].fn.call(u[c].context,t,n,r);break;default:if(!f)for(l=1,f=new Array(a-1);l<a;l++)f[l-1]=arguments[l];u[c].fn.apply(u[c].context,f)}}return!0},s.prototype.on=function(e,t,n){return i(this,e,t,n,!1)},s.prototype.once=function(e,t,n){return i(this,e,t,n,!0)},s.prototype.removeListener=function(e,t,n,r){var o=v?v+e:e;if(!this._events[o])return this;if(!t)return u(this,o),this;var i=this._events[o];if(i.fn)i.fn!==t||r&&!i.once||n&&i.context!==n||u(this,o);else{for(var s=0,f=[],c=i.length;s<c;s++)(i[s].fn!==t||r&&!i[s].once||n&&i[s].context!==n)&&f.push(i[s]);f.length?this._events[o]=1===f.length?f[0]:f:u(this,o)}return this},s.prototype.removeAllListeners=function(e){var t;return e?(t=v?v+e:e,this._events[t]&&u(this,t)):(this._events=new o,this._eventsCount=0),this},s.prototype.off=s.prototype.removeListener,s.prototype.addListener=s.prototype.on,s.prefixed=v,s.EventEmitter=s,void 0!==t&&(t.exports=s)},{}]},{},[1])(1)});

function _extends(){return(_extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function _typeof(t){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}!function(t,e){"object"===("undefined"==typeof exports?"undefined":_typeof(exports))&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):t.LazyLoad=e()}(this,function(){"use strict";var t="undefined"!=typeof window,e=t&&!("onscroll"in window)||"undefined"!=typeof navigator&&/(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent),n=t&&"IntersectionObserver"in window,o=t&&"classList"in document.createElement("p"),r={elements_selector:"img",container:e||t?document:null,threshold:300,thresholds:null,data_src:"src",data_srcset:"srcset",data_sizes:"sizes",data_bg:"bg",class_loading:"loading",class_loaded:"loaded",class_error:"error",load_delay:0,auto_unobserve:!0,callback_enter:null,callback_exit:null,callback_reveal:null,callback_loaded:null,callback_error:null,callback_finish:null,use_native:!1},a=function(t,e){return t.getAttribute("data-"+e)},i=function(t,e,n){var o="data-"+e;null!==n?t.setAttribute(o,n):t.removeAttribute(o)},s=function(t){return"true"===a(t,"was-processed")},c=function(t,e){return i(t,"ll-timeout",e)},l=function(t){return a(t,"ll-timeout")},u=function(t,e){var n,o=new t(e);try{n=new CustomEvent("LazyLoad::Initialized",{detail:{instance:o}})}catch(t){(n=document.createEvent("CustomEvent")).initCustomEvent("LazyLoad::Initialized",!1,!1,{instance:o})}window.dispatchEvent(n)};var d=function(t,e){t&&t(e)},f=function(t,e){t._loadingCount+=e,0===t._elements.length&&0===t._loadingCount&&d(t._settings.callback_finish)},_=function(t){for(var e,n=[],o=0;e=t.children[o];o+=1)"SOURCE"===e.tagName&&n.push(e);return n},v=function(t,e,n){n&&t.setAttribute(e,n)},g=function(t,e){v(t,"sizes",a(t,e.data_sizes)),v(t,"srcset",a(t,e.data_srcset)),v(t,"src",a(t,e.data_src))},m={IMG:function(t,e){var n=t.parentNode;n&&"PICTURE"===n.tagName&&_(n).forEach(function(t){g(t,e)});g(t,e)},IFRAME:function(t,e){v(t,"src",a(t,e.data_src))},VIDEO:function(t,e){_(t).forEach(function(t){v(t,"src",a(t,e.data_src))}),v(t,"src",a(t,e.data_src)),t.load()}},b=function(t,e){var n,o,r=e._settings,i=t.tagName,s=m[i];if(s)return s(t,r),f(e,1),void(e._elements=(n=e._elements,o=t,n.filter(function(t){return t!==o})));!function(t,e){var n=a(t,e.data_src),o=a(t,e.data_bg);n&&(t.style.backgroundImage='url("'.concat(n,'")')),o&&(t.style.backgroundImage=o)}(t,r)},h=function(t,e){o?t.classList.add(e):t.className+=(t.className?" ":"")+e},p=function(t,e,n){t.addEventListener(e,n)},y=function(t,e,n){t.removeEventListener(e,n)},E=function(t,e,n){y(t,"load",e),y(t,"loadeddata",e),y(t,"error",n)},w=function(t,e,n){var r=n._settings,a=e?r.class_loaded:r.class_error,i=e?r.callback_loaded:r.callback_error,s=t.target;!function(t,e){o?t.classList.remove(e):t.className=t.className.replace(new RegExp("(^|\\s+)"+e+"(\\s+|$)")," ").replace(/^\s+/,"").replace(/\s+$/,"")}(s,r.class_loading),h(s,a),d(i,s),f(n,-1)},I=function(t,e){var n=function n(r){w(r,!0,e),E(t,n,o)},o=function o(r){w(r,!1,e),E(t,n,o)};!function(t,e,n){p(t,"load",e),p(t,"loadeddata",e),p(t,"error",n)}(t,n,o)},k=["IMG","IFRAME","VIDEO"],A=function(t,e){var n=e._observer;z(t,e),n&&e._settings.auto_unobserve&&n.unobserve(t)},L=function(t){var e=l(t);e&&(clearTimeout(e),c(t,null))},x=function(t,e){var n=e._settings.load_delay,o=l(t);o||(o=setTimeout(function(){A(t,e),L(t)},n),c(t,o))},z=function(t,e,n){var o=e._settings;!n&&s(t)||(k.indexOf(t.tagName)>-1&&(I(t,e),h(t,o.class_loading)),b(t,e),function(t){i(t,"was-processed","true")}(t),d(o.callback_reveal,t),d(o.callback_set,t))},O=function(t){return!!n&&(t._observer=new IntersectionObserver(function(e){e.forEach(function(e){return function(t){return t.isIntersecting||t.intersectionRatio>0}(e)?function(t,e){var n=e._settings;d(n.callback_enter,t),n.load_delay?x(t,e):A(t,e)}(e.target,t):function(t,e){var n=e._settings;d(n.callback_exit,t),n.load_delay&&L(t)}(e.target,t)})},{root:(e=t._settings).container===document?null:e.container,rootMargin:e.thresholds||e.threshold+"px"}),!0);var e},N=["IMG","IFRAME"],C=function(t,e){return function(t){return t.filter(function(t){return!s(t)})}((n=t||function(t){return t.container.querySelectorAll(t.elements_selector)}(e),Array.prototype.slice.call(n)));var n},M=function(t,e){this._settings=function(t){return _extends({},r,t)}(t),this._loadingCount=0,O(this),this.update(e)};return M.prototype={update:function(t){var n,o=this,r=this._settings;(this._elements=C(t,r),!e&&this._observer)?(function(t){return t.use_native&&"loading"in HTMLImageElement.prototype}(r)&&((n=this)._elements.forEach(function(t){-1!==N.indexOf(t.tagName)&&(t.setAttribute("loading","lazy"),z(t,n))}),this._elements=C(t,r)),this._elements.forEach(function(t){o._observer.observe(t)})):this.loadAll()},destroy:function(){var t=this;this._observer&&(this._elements.forEach(function(e){t._observer.unobserve(e)}),this._observer=null),this._elements=null,this._settings=null},load:function(t,e){z(t,this,e)},loadAll:function(){var t=this;this._elements.forEach(function(e){A(e,t)})}},t&&function(t,e){if(e)if(e.length)for(var n,o=0;n=e[o];o+=1)u(t,n);else u(t,e)}(M,window.lazyLoadOptions),M});

window.theme = window.theme || {};
window.themeInfo = {name: "Foodie"};

var Events = new EventEmitter3();
Events.trigger = Events.emit; // trigger alias

/*============================================================================
 Underground Functions
==============================================================================*/
window.WAU = window.WAU || {};

WAU.Slideout = (function () {

	/*
	 * Elements
	 */
	var wrapper = undefined;

	/*
	 * @description - Makes sure that the ESC Key works to close the menus.
	 */
	document.addEventListener('keyup', function (event) {
		if (event.key === 'Escape') {
			event.preventDefault();
			closeActiveSlideout();
		}
	});

	document.addEventListener('click', function (event) {
		if (event.target === document.querySelector(".js-slideout-overlay")) {
			closeActiveSlideout();
		}
	});

	/*
	 * @description - Closes the currently active slide.
	 */
	function closeActiveSlideout() {
			// Find the open slideout.
			const activeSlideout = document.querySelector('.slideout--active');
			const activeSlideoutName = activeSlideout.getAttribute('data-wau-slideout');
			const opener = document.querySelector('.js-slideout-open[data-wau-slideout-target="' + activeSlideoutName + '"]');
			const direction = opener ? opener.getAttribute('data-slideout-direction') : 'left';
      const accordionsClosed = activeSlideout.getAttribute('data-wau-accordions-closed');

      if ( accordionsClosed !== null ) {
        WAU.Accordion.hideAll(activeSlideoutName);
      }

			close(direction, opener);
	}

	/*
	 * @description - Checks if the slideout is currently open or not.
	 * @return Boolean
	 */
	function isOpen() {
		wrapper = document.querySelector(".js-slideout-toggle-wrapper");
		return wrapper.classList.contains("slideout-left--open") || wrapper.classList.contains("slideout-right--open");
	}

	/*
	 * @description - Open a specific slideout in a specific direction.
	 * @param direction:String - the drction to open the slideout in.
	 * @param targetSlideoutEl:Node - The slideout element that will be opened.
	 */
	function open(direction, targetSlideoutEl, opener) {
		wrapper.classList.add("slideout-" + direction + "--open");
		wrapper.classList.remove("slideout-" + direction + "--closed");

		opener.setAttribute("aria-expanded", "true");

    // Fix body wrapper so no scrolling on mobile
    let scrollPosition = Math.abs(0 - document.querySelector('.site-wrap').getBoundingClientRect().top);

    let slideoutName = targetSlideoutEl.dataset.wauSlideout;

    Events.trigger('slideout:open:' + slideoutName);

    // Aria and Active classes
    targetSlideoutEl.setAttribute('aria-hidden', 'false');

    setTimeout(function(){
      targetSlideoutEl.classList.add('slideout--active');
      targetSlideoutEl.classList.remove('slideout--close');
    }, 350);

    // Trapfocus on slideout until closed
    trapFocus(targetSlideoutEl)

    wrapper.style.overflow = 'hidden';
    wrapper.style.position = 'fixed';

    wrapper.style.overflow = 'hidden';
    wrapper.style.position = 'fixed';
    wrapper.style.top = `-${scrollPosition}px`;
    wrapper.style.width = '100%';
	}

	/*
	 * @description - Closes all slideouts. Puts a11y focus back on the original opener.
	 * @param opener:Node - the opener element.
	 */
	function close(direction, opener) {
		const activeOpenSlideouts = document.querySelectorAll('.slideout--active');
		const openers = document.querySelectorAll(".js-slideout-open");
		const closers = document.querySelectorAll(".js-slideout-close");

		// Remove content if quickview
		if (opener && opener.getAttribute("aria-controls") == 'quickview') {
			document.querySelector('.js-quickview-content').innerHTML = '';
		}

		// Close the slideout.
		wrapper.classList.remove("slideout-" + direction + "--open");
		wrapper.classList.add("slideout-" + direction + "--closed");

		// Close all active drawers. This is incase there is more than 1 slide on a direction.
		activeOpenSlideouts.forEach(function (activeSlideoutDrawer) {
			activeSlideoutDrawer.classList.remove('slideout--active');

      const accordionsClosed = activeSlideoutDrawer.getAttribute('data-wau-accordions-closed');
      const activeSlideoutName = activeSlideoutDrawer.getAttribute('data-wau-slideout');

      if ( accordionsClosed !== null ) {
        WAU.Accordion.hideAll(activeSlideoutName);
      }

      Events.trigger('slideout:close:' + activeSlideoutName);

      // Aria and Active classes
      activeSlideoutDrawer.classList.remove('slideout--active');
      activeSlideoutDrawer.classList.add('slideout--close');

      setTimeout(function(){
        activeSlideoutDrawer.setAttribute('aria-hidden', 'true');
      }, 350);

      // Remove focus on button
      if (activeSlideoutDrawer.querySelector('.js-slideout-close')) activeSlideoutDrawer.querySelector('.js-slideout-close').blur();
		});

		// Makes sure aria-expanded false is added to all the open and close buttons.
		openers.forEach(function (opener) {
			opener.setAttribute('aria-expanded', 'false');
		});

		closers.forEach(function (closer) {
			closer.setAttribute('aria-expanded', 'false');
		});

    // Fix body wrapper so no scrolling on mobile
    let scrollPosition = Math.abs(0 - document.querySelector('.site-wrap').getBoundingClientRect().top);

    wrapper.style.removeProperty('overflow');
    wrapper.style.removeProperty('position');
    wrapper.style.removeProperty('top');
    wrapper.style.removeProperty('width');
    window.scrollTo(0, scrollPosition);
	}

	/*
	 * @description - Closes a specific slideout given the name in data-wau-slideout attribute
	 * @return void
	 */
	function closeByName(name) {
		const closer = document.querySelector('[data-wau-slideout-target="' + name + '"]');
		const direction = closer.getAttribute('data-slideout-direction');
		const opener = document.querySelector('.js-slideout-open[data-wau-slideout-target="' + name + '"]');
		close(direction, opener);
	}

	/*
	 * @description - Opens a specific slideout given the name in data-wau-slideout attribute
	 * @return void
	 */
	function openByName(name) {
		const opener = document.querySelector('[data-wau-slideout-target="' + name + '"]')
		const direction = opener.getAttribute('data-slideout-direction');
		const targetSlideoutEl = document.querySelector('[data-wau-slideout="' + name + '"]');
		open(direction, targetSlideoutEl, opener);
	}

	/*
	 * @description - Creates a new aside element to be used as a slideout.
	 * @param direction:String - the direction that the slideout will open in. "left" or "right"
	 * @param name:String - An explicit name to refer to the slideout by on a trigger.
	 * @param wrapperEl:Node - An element that can be explicitly passed in as the wrapper element.
	 */
  function createSlideoutEl(direction, name, wrapperEl) {

     const aside = document.createElement('aside');
     const innerDiv = document.createElement('div');
     const innerContentDiv = document.createElement('div');
     const opener = document.querySelector('[data-wau-slideout-target="' + name + '"]');
     const content = document.querySelector('[data-wau-slideout-content="' + name + '"]');
     const generatedId = "slideout-" + name;

 		wrapperEl = wrapperEl || wrapper;

    if ( content.hasAttribute('data-wau-accordions-closed') ) {
      aside.setAttribute('data-wau-accordions-closed', '');
    }

     // Create outer wrapper
     aside.classList.add('slideout');
     aside.classList.add('slideout__drawer-' + direction);
     aside.setAttribute('data-wau-slideout', name);
     aside.setAttribute('id', generatedId); // setting an id here so that we can set the aria-controls attribute on the opener.

     // Create inner wrapper and move content to it
     innerDiv.classList.add('slideout__inner-wrapper');
     innerDiv.classList.add('slideout__general-slide__wrapper');
     innerContentDiv.innerHTML = content.innerHTML;
     innerContentDiv.classList.add('slideout__inner-content-container');

 		// Empty content so no conflict
 		content.innerHTML = '';

     // Add close button to Inner
 		if ( content.dataset.wauSlideoutButton && content.dataset.wauSlideoutButton == 'true' ) {
 			let closeDiv = createCloser(name, direction);
 			innerDiv.prepend(closeDiv);
 		}

     // Add inner wrapper to outer wrapper
     aside.appendChild(innerDiv);
     innerDiv.appendChild(innerContentDiv);

 		opener.setAttribute('aria-controls', generatedId);
 		wrapperEl.appendChild(aside);

 		return aside;
 	}


	/*
	 * @description - Empties inner wrapper of slideout and replaces content with previous content
	 */
	function reloadSlideoutContents(name) {
		const content = document.querySelector('[data-wau-slideout-content="' + name + '"]');
		const drawer = document.querySelector('aside[data-wau-slideout="' + name + '"]');
		const innerWrapper = drawer.querySelector('.slideout__inner-content-container');

		innerWrapper.innerHTML = content.innerHTML;
	}

/*
   * @description - Traps keyboard focus inside slideout when open
   */
  function trapFocus(activeSlideout) {
     // add all the elements inside modal which you want to make focusable
    const  focusableElements =
        'button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])';

    const firstFocusableElement = activeSlideout.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
    const focusableContent = activeSlideout.querySelectorAll(focusableElements);
    const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

    document.addEventListener('keydown', function(e) {
      let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey) { // if shift key pressed for shift + tab combination
        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus(); // add focus for the last focusable element
          e.preventDefault();
        }
      } else { // if tab key is pressed
        if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
          firstFocusableElement.focus(); // add focus for the first focusable element
          e.preventDefault();
        }
      }
    });

    firstFocusableElement.focus();
  }

	/*
	 * @description - Initializes the plugin by adding all of the appropriate event listeners.
	 */
  function init(name) {
    if (typeof name === "undefined") {
      console.log("The Slideout must have an associated name.");
      return;
    }

    wrapper = document.querySelector('.js-slideout-toggle-wrapper');

    const slideoutOpeners = document.querySelectorAll('.js-slideout-open[data-wau-slideout-target="' + name + '"]');

    let slideoutTargetEl = undefined;

   slideoutOpeners.forEach((slideoutOpener, i) => {
     const slideoutDirection = slideoutOpener.getAttribute('data-slideout-direction');

     if (slideoutOpener) {
       slideoutTargetEl = document.querySelector(`aside[data-wau-slideout=${name}]`);
     }

     if (!slideoutTargetEl) {
       slideoutTargetEl = createSlideoutEl(slideoutDirection, name, wrapper);
     }

     // Set tabindex so it skips hidden slideout

    // Set Aria Hidden on Load
    slideoutTargetEl.setAttribute('aria-hidden', 'true');

    // Trigger event for outside functions to listen and use
     Events.trigger('slideout:active:' + name);
     slideoutOpener.addEventListener('click', function () {
       open(slideoutDirection, slideoutTargetEl, slideoutOpener);
     });

   });

   const slideoutClosers = document.querySelectorAll('.js-slideout-close');

    slideoutClosers.forEach((slideoutCloser, i) => {
      const slideoutCloseDirection = slideoutCloser.getAttribute('data-slideout-direction');
      slideoutCloser.addEventListener('click', function () {
        close(slideoutCloseDirection, slideoutCloser);
      });
    });
  }

	const privateFunctions = {
		openByName,
		closeByName,
		createSlideoutEl,
    reloadSlideoutContents
	};

	let returnObj = {};

	returnObj.init = init;

	/*
	 * @description - Gives WAU.Slideout external access to the internal functions for use in Shopify Events.
	 */
	Object.keys(privateFunctions).forEach(function (pf) {
		returnObj['_' + pf] = privateFunctions[pf];
	});

	return returnObj;

}());

WAU.Modal = (function() {
  /*
   * Elements
   */
  var wrapper = undefined;
  /*
   * @description - Makes sure that the ESC Key works to close the menus.
   */
  document.addEventListener('keyup', function(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeActiveModal();
    }
  });
  document.addEventListener('click', function(event) {
    if (event.target === document.querySelector(".js-modal-overlay")) {
      closeActiveModal();
    }
  });
  /*
   * @description - Closes the currently active modal.
   */
  function closeActiveModal() {
    // Find the open modal.
    const activeModal = document.querySelector('.modal--active');
    const activeModalName = activeModal.getAttribute('data-wau-modal');
    const closer = activeModal.querySelector('.js-modal-close');

    close(closer);
  }
  /*
   * @description - Checks if the modal is currently open or not.
   * @return Boolean
   */
  function isOpen() {
    wrapper = document.querySelector(".js-modal-toggle-wrapper");
    return wrapper.classList.contains("modal--open");
  }
  /*
   * @description - Open a specific modal.
   * @param targetSlideoutEl:Node - The modal element that will be opened.
   */
  function open(targetModalEl, opener) {

		// Fix body wrapper so no scrolling on mobile
    let scrollPosition = Math.abs(0 - document.querySelector('.site-wrap').getBoundingClientRect().top);
    wrapper.style.width = '100%';

		if ( targetModalEl.hasAttribute("data-wau-modal-full") ) {
			wrapper.style.overflowY = 'hidden';
		} else {
			// Stop from scrolling to top
			targetModalEl.style.top = `calc(${scrollPosition}px + 10vh)`;
		}

    wrapper.classList.add("modal--open");
    wrapper.classList.remove("modal--closed");
    targetModalEl.classList.add('modal--active');

    // Add specific modal type class
    if ( targetModalEl.getAttribute("data-wau-modal") ) {
      var elClass = targetModalEl.getAttribute("data-wau-modal"),
          elClass = "modal-" + elClass + "--open";
      wrapper.classList.add(elClass);
    }

    opener.setAttribute("aria-expanded", "true");
  }
  /*
   * @description - Closes all modals. Puts a11y focus back on the original opener.
   * @param opener:Node - the opener element.
   */
  function close(openerEl) {
    const activeOpenModals = document.querySelectorAll('.modal--active');
    const openers = document.querySelectorAll(".js-modal-open");
    const closers = document.querySelectorAll(".js-modal-close");

    // Remove content if quickview
    if (openerEl && openerEl.getAttribute("aria-controls") == 'quickview') {
      document.querySelector('.js-quickview-content').innerHTML = '';
    }

    // Close the Modal.
    wrapper.classList.remove("modal--open");
    wrapper.classList.add("modal--closed");

    // Close all active modals. This is incase there is more than 1..
    activeOpenModals.forEach(function(activeModalDrawer) {
      // Remove specific modal type class
      if ( activeModalDrawer.getAttribute("data-wau-modal") ) {
        var elClass = activeModalDrawer.getAttribute("data-wau-modal"),
            elClass = "modal-" + elClass + "--open";
        wrapper.classList.remove(elClass);
      }

      activeModalDrawer.classList.remove('modal--active');

			// For full width modal
			if ( activeModalDrawer.hasAttribute("data-wau-modal-full") ) {
				wrapper.style.overflowY = 'unset';
			}

    });

    // Makes sure aria-expanded false is added to all the open and close buttons.
    openers.forEach(function(opener) {
      opener.setAttribute('aria-expanded', 'false');
    });
    closers.forEach(function(closer) {
      closer.setAttribute('aria-expanded', 'false');
    });

    // Fix body wrapper so no scrolling on mobile
    wrapper.style.removeProperty('overflow');
    wrapper.style.removeProperty('position');
    wrapper.style.removeProperty('padding-right');
    wrapper.style.removeProperty('top');
    wrapper.style.removeProperty('width');
  }
  /*
   * @description - Closes a specific modal given the name in data-wau-slideout attribute
   * @return void
   */
  function closeByName(name) {
    const closer = document.querySelector('[data-wau-modal-target="' + name + '"]');
    const opener = document.querySelector('.js-modal-open[data-wau-modal-target="' + name + '"]');
    close(opener);
  }
  /*
   * @description - Opens a specific modal given the name in data-wau-slideout attribute
   * @return void
   */
  function openByName(name) {
    const opener = document.querySelector('[data-wau-modal-target="' + name + '"]');
    const targetModalEl = document.querySelector('[data-wau-modal="' + name + '"]');
    open(targetModalEl, opener);
  }
  /*
   * @description - Creates a new close button inside created modal.
   * @param name:String - An explicit name to refer to the modal by on a trigger.
   */
  function createCloser(name) {
    const closeDiv = document.createElement('div');
    const button = document.createElement('button');
    const icon = document.createElement('div');
    closeDiv.classList.add('slideout__trigger--close');
    closeDiv.classList.add('slideout__trigger-' + name + '__wrapper');
    closeDiv.classList.add('slideout__trigger-general-modal__wrapper');
    button.classList.add('slideout__trigger-' + name);
    button.classList.add('slideout__trigger-general-modal');
    button.classList.add('js-modal-close');
    button.setAttribute('aria-controls', 'modal-' + name);
    button.setAttribute('aria-label', 'Close modal');
    icon.classList.add('icn-close');
    button.appendChild(icon);
    closeDiv.appendChild(button);
    return closeDiv;
  }
  /*
   * @description - Creates a new div element to be used as a modal.
   * @param name:String - An explicit name to refer to the modal by on a trigger.
   * @param wrapperEl:Node - An element that can be explicitly passed in as the wrapper element.
   */
  function createModalEl(name, wrapperEl) {
    const div = document.createElement('div');
    const innerDiv = document.createElement('div');
    const innerContentDiv = document.createElement('div');
    const opener = document.querySelector('[data-wau-modal-target="' + name + '"]');
    const content = document.querySelector('[data-wau-modal-content="' + name + '"]');
    const generatedId = "modal-" + name;
    wrapperEl = wrapperEl || wrapper;

    // Create outer wrapper
    div.classList.add('modal');
    div.classList.add('modal__container');
		div.setAttribute('data-wau-modal', name);
		div.setAttribute('id', generatedId); // setting an id here so that we can set the aria-controls attribute on the opener.

		// Set full width
		if ( content && content.hasAttribute('data-wau-modal-full') ) {
			div.setAttribute('data-wau-modal-full', '');
		}

    // Create inner wrapper and move content to it
    innerDiv.classList.add('modal__inner-wrapper');
    innerDiv.classList.add('modal__general-modal__wrapper');
    innerContentDiv.innerHTML = content.innerHTML;
    innerContentDiv.classList.add('modal__inner-content-container');

    // Add close button to Inner
    let closeDiv = createCloser(name);
    innerDiv.prepend(closeDiv);

    // Add inner wrapper to outer wrapper
    div.appendChild(innerDiv);
    innerDiv.appendChild(innerContentDiv);
    opener.setAttribute('aria-controls', generatedId);
    wrapperEl.appendChild(div);
    return div;
  }
  /*
   * @description - Initializes the plugin by adding all of the appropriate event listeners.
   */
  function init(name) {
    if (typeof name === "undefined") {
      console.log("The Modal must have an associated name.");
      return;
    }
    wrapper = document.querySelector('.js-modal-toggle-wrapper');
    const modalOpeners = document.querySelectorAll('.js-modal-open[data-wau-modal-target="' + name + '"]');

    let modalTargetEl = undefined;
    if (modalOpeners) {
      modalTargetEl = document.querySelector(`div[data-wau-modal=${name}]`);
    }

    if (!modalTargetEl) {
      modalTargetEl = createModalEl(name, wrapper);
    }

    modalOpeners.forEach((modalOpener, i) => {
      modalOpener.addEventListener('click', function() {
        open(modalTargetEl, modalOpener);
      });
    });

    const modalClosers = document.querySelectorAll('.js-modal-close');
    modalClosers.forEach(function(modalCloser) {
      modalCloser.addEventListener('click', function() {
        close(modalCloser);
      });
    });
  }
  const privateFunctions = {
    openByName,
    closeByName,
    createModalEl
  };
  let returnObj = {};
  returnObj.init = init;
  /*
   * @description - Gives WAU.Slideout external access to the internal functions for use in Shopify Events.
   */
  Object.keys(privateFunctions).forEach(function(pf) {
    returnObj['_' + pf] = privateFunctions[pf];
  });
  return returnObj;
}());

WAU.Accordion = (function () {

  const classes = {
    show: "is-active",
    open: "js-accordion-is-open",
    mobileNavAccordion: "js-accordion-mobile-nav"
  };

  const selectors = {
    accordion: ".js-accordion",
    accordionItem: '.c-accordion__item',
    accordionLink: ".js-accordion-link",
    accordionHeader: ".js-accordion-header",
    accordionPanel: ".c-accordion__panel"
  };

  const publicAPIs = {};

  /*
   * @description strips class period
   */
  const stripClassPeriod = function(className) {
    if (!className) return;
    return className.split('.')[1];
  }

  /*
   * @description returns class naem
   */
  publicAPIs.getConfigClass = function (className) {
    if (!className) return;
    if (classes[className] && classes[className] != '') {
      return classes[className];
    } else {
      return false;
    }
  };

  /*
   * @description Hides an accordion item
   */
  publicAPIs.hide = function (target) {

    target.setAttribute("aria-expanded", "false");
		target.parentNode.classList.remove('accordion-expanded');

    const panel = document.querySelector(
      `#${target.getAttribute("aria-controls")}`
    );

    panel.setAttribute("hidden", "");

    // 350 matches the CSS transition timing
    setTimeout(function(){
      panel.style.display = "none";
    }, 350);
  };

  /*
   * @description Hides all accordion items at once
   */
  publicAPIs.hideAll = function (name) {
    const accordion = document.querySelector('[data-accordion-family="' + name + '"]');

    if ( !accordion ) return false;

    const accordionHeaders = document.querySelectorAll('[data-accordion-family="' + name + '"] > .js-accordion-header');

    accordionHeaders.forEach((item, i) => {
      const target = item.querySelector('[data-toggle="accordion"]');

      // Close each accordion item
      target.setAttribute("aria-expanded", "false");
  		target.parentNode.classList.remove('accordion-expanded');

      const panel = document.querySelector(
        `#${target.getAttribute("aria-controls")}`
      );

      panel.setAttribute("hidden", "");

      // 350 matches the CSS transition timing
      setTimeout(function(){
        panel.style.display = "none";
      }, 350);

    });

  };

  /*
   * @description Shows an accordion item
   */
  publicAPIs.show = function (target, allowMultiple) {

    const panel = document.querySelector(
      `#${target.getAttribute("aria-controls")}`
    );

    const parentElement = target.closest(panel.getAttribute("data-parent"));

    const allowMultipleFlag = allowMultiple || parentElement
      .hasAttribute("data-accordion-allow-multiple") ? true : false;

    const isMobileNav = parentElement.classList.contains(classes.mobileNavAccordion);

    if (!allowMultipleFlag && panel.hasAttribute("data-parent")) {

      let childSelector = '';

      if (isMobileNav) {
        childSelector = ':scope > li > [aria-expanded="true"]';
      } else {
        childSelector = ':scope > [aria-expanded="true"]';
      }

      if (!childSelector) {
        return;
      }

      const activePanels = target
        .closest(panel.getAttribute("data-parent"))
        .querySelectorAll(
        childSelector
      );

      if (!activePanels) {
        return;
      }

      activePanels.forEach(function (element) {
        publicAPIs.hide(element);
      });
    }

    target.setAttribute("aria-expanded", "true");
		target.parentNode.classList.add('accordion-expanded');

    panel.removeAttribute("hidden");

    panel.style.display = "block";

  };

  /*
   * @description Toggle showing and hiding an accordion item
   */
  publicAPIs.toggle = function (target, allowMultiple) {

    if (target.getAttribute("aria-expanded") == "true") {
      publicAPIs.hide(target);
      return;
    } else {
      publicAPIs.show(target, allowMultiple);
    }
  };

  /*
   * @description Initialize function
   */
  publicAPIs.init = function () {

    // Hide add accordion panels
    document.querySelectorAll(`[data-toggle="accordion"]:not(.${classes.open})`).forEach(function(element, index) {
      publicAPIs.hide(element);
    });

    // Add keyboard accessibility events
    document.addEventListener('keydown', function(event) {
      let target = event.target;
      const key = event.which.toString();
      const disablePageScroll = false;
      const pageScrollOptions = disablePageScroll ? {preventScroll: true} : {preventScroll: false};
      const isDropDownArrow = target.classList.contains('dropdown-arrow');

      if (target.classList.contains(stripClassPeriod(selectors.accordionHeader)) ||
          target.classList.contains(stripClassPeriod(selectors.accordionLink)) ||
          isDropDownArrow ) {

        if (key.match(/38|40/)) {

          const isMobile = target.closest(selectors.accordion).classList.contains(classes.mobileNavAccordion) ? true : false;

          const accordionSelector = isMobile ? `:scope > li > ${selectors.accordionLink}` : `:scope > ${selectors.accordionHeader}`;

          const accordions = target.closest(selectors.accordion).querySelectorAll(accordionSelector);

          if (isMobile && isDropDownArrow) {
            target.previousElementSibling.focus(pageScrollOptions);
            return;
          }

          let indexPlace;
          accordions.forEach(function(element, index) {
            if (element == target) {
              indexPlace = index;
            }
          });
          const direction = key.match(/34|40/) ? 1 : -1;
          const length = accordions.length;
          const newIndex = (indexPlace + length + direction) % length;

          accordions[newIndex].focus(pageScrollOptions);
        }
      }
    });

    document.addEventListener("click", function (event) {

      const target = event.target.matches('[data-toggle="accordion"]') ? event.target : event.target.closest('[data-toggle="accordion"]');

      if (!target) {
        return false;
      }

			event.preventDefault();

      publicAPIs.toggle(target);
    });

		document.addEventListener("click", function (event) {
			if ( event.target.classList.contains('js-accordion-link') ) {
				let url = event.target.getAttribute('href');
				if ( url == '' ) {
					event.preventDefault();

					let target = event.target.parentNode.querySelector('[data-toggle="accordion"]');
					publicAPIs.toggle(target);
				}
			}
		});
  };

  return publicAPIs;

})();

WAU.Helpers = (function() {
  var touchDevice = false;

  function setTouch() {
    touchDevice = true;
  }

  function isTouch() {
    return touchDevice;
  }

  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this,
        args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

	function makeSticky(amountToScroll, elementClass, elementHeight) {
    const clearElement = document.querySelector(".js-clear-element"),
          stickyElement = document.querySelector(elementClass),
          height = elementHeight  + "px";

    if (window.pageYOffset > amountToScroll) {
      stickyElement.classList.add('sticky--active');
      clearElement.style.height = height;
    } else {
      stickyElement.classList.remove('sticky--active');
      clearElement.style.height = "0px";
    }
  }

	function showHide(show, hide) {
	  var show = document.getElementById(show);
	  show.classList.remove("hide");
	  show.classList.add("show");
	  show.style.display = 'block';

	  var hide = document.getElementById(hide);
	  hide.classList.remove("show");
	  hide.classList.add("hide");
	  hide.style.display='none';
	}

  function Toggle(id) {
    var element = document.getElementById(id);
    if ( element.classList.contains('animate-hide') ) {
      element.classList.remove("animate-hide", "fadeOut");
      element.classList.add("animate-show", "fadeIn");
      element.style.visibility = "visible";
    } else {
	  element.classList.remove("animate-show", "fadeIn");
      element.classList.add("animate-hide", "fadeOut");
      element.style.visibility = "hidden";
    }
  }

  function toggleClass(id, className) {
    var element = document.getElementById(id);
    if (!element) return false;
    if ( element.classList.contains(className) ) {
      element.classList.remove(className);
    } else {
      element.classList.add(className);
    }
  }

  function Accordion(container, tlink, submenu) {

    let accorContent = container.querySelector(submenu);

    if ( !container.querySelector(tlink) ) return false;

    container.querySelector(tlink).addEventListener('click', function(event) {
      event.preventDefault();

      // Toggle class on label and update a11y
      if ( this.classList.contains('closed') ) {
        this.classList.remove('closed');
        this.parentElement.classList.remove('closed');
        this.setAttribute('aria-expanded', 'true');
      } else {
        this.classList.add('closed');
        this.parentElement.classList.add('closed');
        this.setAttribute('aria-expanded', 'false');
      }

      // Show content
      if ( accorContent.classList.contains('closed') ) {
        accorContent.classList.remove("closed");
        accorContent.style.display = "block";
      } else {
        accorContent.classList.add("closed");
        accorContent.style.display = "none";
      }

    });
  }

  function fadeOut(el){
    el.style.opacity = 1;

    (function fade() {
      if ((el.style.opacity -= 0.1) < 0) {
        el.style.display = "none";
      } else {
        requestAnimationFrame(fade);
      }
    })();
  }

  function fadeToggle(el, display) {
    var style = display || "block";

    if (el.style.display === 'none') {
      el.style.opacity = 0;
      el.style.display = display || "block";

      (function fade() {
        var val = parseFloat(el.style.opacity);
        if (!((val += 0.1) > 1)) {
          el.style.opacity = val;
          requestAnimationFrame(fade);
        }
      })();

    } else if (el.style.display === style) {
      el.style.opacity = 1;

      (function fade() {
        if ((el.style.opacity -= 0.1) < 0) {
          el.style.display = "none";
        } else {
          requestAnimationFrame(fade);
        }
      })();
    }
  }

  function fadeIn(el, display){
    el.style.opacity = 0;
    el.style.display = display || "block";

    (function fade() {
      var val = parseFloat(el.style.opacity);
      if (!((val += 0.1) > 1)) {
        el.style.opacity = val;
        requestAnimationFrame(fade);
      }
    })();
  }

  function getScrollbarWidth() {

    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);

    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);

    // Calculating difference between container's full width and the child width
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);

    return scrollbarWidth;

  }

  function smoothScrollTo(endX, endY, duration) {
     let startX = window.scrollX || window.pageXOffset,
     startY = window.scrollY || window.pageYOffset,
     distanceX = endX - startX,
     distanceY = endY - startY,
     startTime = new Date().getTime();
     // Easing function
     let easeInOutQuart = function(time, from, distance, duration) {
         if ((time /= duration / 2) < 1) return distance / 2 * time * time * time * time + from;
         return -distance / 2 * ((time -= 2) * time * time * time - 2) + from;
     };
     let timer = window.setInterval(function() {
         let time = new Date().getTime() - startTime,
         newX = easeInOutQuart(time, startX, distanceX, duration),
         newY = easeInOutQuart(time, startY, distanceY, duration);
         if (time >= duration) {
             window.clearInterval(timer);
         }
         window.scrollTo(newX, newY);
     }, 1000 / 60); // 60 fps
  }

	function wrapIframe(options) {
		options.iframes.forEach(function(iframe) {
			var wrapper = document.createElement('div');
			wrapper.classList.add(options.iframeWrapperClass);

			iframe.parentNode.insertBefore(wrapper, iframe);
			wrapper.appendChild(iframe);

			iframe.src = iframe.src;
		});
	}

	function wrapTable(options) {
	 options.tables.forEach(function(table) {
		 var wrapper = document.createElement('div');
		 wrapper.classList.add(options.tableWrapperClass);

		 table.parentNode.insertBefore(wrapper, table);
		 wrapper.appendChild(table);
	 });
	}

	function scriptLoader() {
		  /**
		   * Promise-based script loader
		   * @param {string} url
		   * @param {object=} attr
		   * @returns {Promise}
		   */
		  const loader = (url, attr) => new Promise((resolve, reject) => {
		    const script = window.document.createElement('script');
		    script.src = url;
		    script.async = true;
		    script.crossOrigin = 'anonymous';

		    attr = attr || {};

		    for (const attrName in attr) {
		      script[attrName] = attr[attrName];
		    }

		    script.addEventListener('load', () => {
		      resolve(script);
		    }, false);

		    script.addEventListener('error', () => {
		      reject(script);
		    }, false);

				function scriptExists(url) {
				  return document.querySelectorAll(`script[src="${url}"]`).length > 0;
				}

				if ( !scriptExists(url) ) {
					window.document.head.appendChild(script);
				} else {
					resolve(script);
				}

		  });

		  /**
		   * Loads scripts asynchronously
		   * @param {string|string[]} urls
		   * @param {object=} attr Other script tag attributes
		   * @returns {Promise}
		   */
		  this.load = (urls, attr) => {
		    if (!Array.isArray(urls)) {
		      urls = [urls];
		    }

		    return Promise.all(urls.map(url => loader(url, attr)));
		  }

		  /**
		   * Loads scripts asynchronously. It supports multiple url arguments, so each one will be loaded right after the
		   * previous is loaded. This is a way of chaining dependency loading.
		   *
		   * @param {string|string[]} urls, ...
		   * @returns {Promise}
		   */
		  this.loadChain = function (urls) {
		    const args = Array.isArray(arguments) ? arguments : Array.prototype.slice.call(arguments);
		    const p = this.require(args.shift());
		    const self = this;
		    return args.length ? p.then(() => {
		      self.requireChain(...args);
		    }) : p;
		  }
	}

	function scriptExists(url) {
		return document.querySelectorAll(`script[src="${url}"]`).length > 0;
	}

	function isElementPastEdge(element) {
		const bounding = element.getBoundingClientRect(),
					l = bounding.left,
					w = bounding.width,
					docH = document.documentElement.clientHeight,
					docW = document.documentElement.clientWidth;

		return (l + w >= docW);
	}

  function lazyLoad(element, native) {
    new LazyLoad({
      elements_selector: element,
      use_native: native // This one
    });
  }

	function formatMoney(cents, format) {
		const moneyFormat = '${{amount}}';

	  if (typeof cents === 'string') {
	    cents = cents.replace('.', '');
	  }
	  let value = '';
	  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
	  const formatString = format || moneyFormat;

	  function formatWithDelimiters(
	    number,
	    precision = 2,
	    thousands = ',',
	    decimal = '.'
	  ) {
	    if (isNaN(number) || number == null) {
	      return 0;
	    }

	    number = (number / 100.0).toFixed(precision);

	    const parts = number.split('.');
	    const dollarsAmount = parts[0].replace(
	      /(\d)(?=(\d\d\d)+(?!\d))/g,
	      `$1${thousands}`
	    );
	    const centsAmount = parts[1] ? decimal + parts[1] : '';

	    return dollarsAmount + centsAmount;
	  }

	  switch (formatString.match(placeholderRegex)[1]) {
	    case 'amount':
	      value = formatWithDelimiters(cents, 2);
	      break;
	    case 'amount_no_decimals':
	      value = formatWithDelimiters(cents, 0);
	      break;
	    case 'amount_with_comma_separator':
	      value = formatWithDelimiters(cents, 2, '.', ',');
	      break;
	    case 'amount_no_decimals_with_comma_separator':
	      value = formatWithDelimiters(cents, 0, '.', ',');
	      break;
	  }

	  return formatString.replace(placeholderRegex, value);
	}

	return {
    setTouch: setTouch,
    isTouch: isTouch,
    debounce: debounce,
		makeSticky: makeSticky,
		showHide: showHide,
    Toggle: Toggle,
    toggleClass: toggleClass,
    Accordion: Accordion,
    fadeToggle: fadeToggle,
    fadeOut: fadeOut,
    fadeIn: fadeIn,
    getScrollbarWidth: getScrollbarWidth,
    smoothScrollTo: smoothScrollTo,
    wrapIframe: wrapIframe,
    wrapTable: wrapTable,
		scriptLoader: scriptLoader,
		scriptExists: scriptExists,
		isElementPastEdge: isElementPastEdge,
    lazyLoad: lazyLoad,
		formatMoney: formatMoney
  };
})();

WAU.a11yHelpers = (function () {

	let alreadySetUpKeyEvents = false;

	/*
	 * @description - Sets up the aria-expanded property to true and false on hover.
	 */
	function setUpAriaExpansion() {
		const ariaExpandEls = document.querySelectorAll('.js-aria-expand');

		ariaExpandEls.forEach(function (ariaExpandEl) {
			ariaExpandEl.addEventListener('mouseover', function (event) {
				ariaExpandEl.setAttribute('aria-expanded', 'true');
		});

			ariaExpandEl.addEventListener('mouseout', function (event) {
				ariaExpandEl.setAttribute('aria-expanded', 'false');
			});
		});
	}

	/*
	 * @description - Takes a parent element and focuses on the next focusable element inside of there.
	 */
	function focusOnElement(parent) {
		var focussableElements = 'a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';

		const elementToFocusOn = parent.querySelector(focussableElements);

		if (elementToFocusOn) {
			elementToFocusOn.focus();
		}

	}

	function findFocusableElement(parent, element, direction) {
		const focusableElementSelectors = 'a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
		const focusableElements = parent.querySelectorAll(focusableElementSelectors);
		const numOfFocusableElements = focusableElements.length;

		var elementIndex = 0;

		for (let i = 0; i < focusableElements.length; i += 1) {
			let currentElement = focusableElements[i];

			if (currentElement === element) {
				elementIndex = i;
			}
		}

		if (direction === 'next') {
			if (elementIndex === (numOfFocusableElements - 1)) {
				return focusableElements[0];
			} else {
				return focusableElements[elementIndex + 1];
			}
		}

		if (direction === 'prev') {
			if (elementIndex === 0) {
				return focusableElements[numOfFocusableElements - 1];
			} else {
				return focusableElements[elementIndex - 1];
			}
		}
	}

	/*
	 * @description - Takes a parent and a dom node and returns the next element that is focusable that is not the current element.
	 * @param parent:DOMNode
	 * @param element:DOMNode
	 * @return DOMNode
	 */
	function findNextFocusableElement(parent, element) {
		return findFocusableElement(parent, element, 'next');
	}

	function findPreviousFocusableElement(parent, element) {
		return findFocusableElement(parent, element, 'prev');
	}

			/*
	 * @description - Enables accessible keyboard navigation throughout the navigation menus.
	 */
	function setUpAccessibleNavigationMenus() {

		function closeDropdownMenus() {
			const activeMenuItems = document.querySelectorAll('.navigation__menuitem--active');
			activeMenuItems.forEach(function (activeMenuItem) {
				activeMenuItem.classList.remove('navigation__menuitem--active');
				activeMenuItem.setAttribute('aria-expanded', 'false');
			});
		}

		function closeNestedDropdownMenus() {
			//remove the class that makes the dropdown show... the active class
			const nestedDropdowns = document.querySelectorAll(".js-menuitem-with-nested-dropdown");

			nestedDropdowns.forEach(function (nestedDropdown) {
				nestedDropdown.classList.remove("dropdown__menuitem--active");
				nestedDropdown.setAttribute('aria-expanded', 'false');
			});

		}

		function addEdgeToDropdown(dropdown) {
			setTimeout(function () {
				if (WAU.Helpers.isElementPastEdge(dropdown)) {
					dropdown.classList.add("dropdown--edge");
				} else {
					dropdown.classList.remove("dropdown--edge");
				}
			}, 0);
		}

		if (!alreadySetUpKeyEvents) {
			document.addEventListener('keyup', function (event) {
				if (event.key === 'Escape') {
					const openNestedDropdownMenus = document.querySelectorAll(".dropdown__menuitem--active"),
								openDropdownMenus = document.querySelectorAll(".navigation__menuitem--active");

					event.preventDefault();

					if (openNestedDropdownMenus.length >= 1) {
						closeNestedDropdownMenus();
						return;
					}

					if (openDropdownMenus.length >= 1) {
						closeDropdownMenus();
						return;
					}

				}
			});
		}

		if (!alreadySetUpKeyEvents) {
			document.addEventListener('keydown', function (event) {
				if (event.key === 'Enter') {

					if (document.activeElement.classList.contains("js-open-dropdown-on-key") || document.activeElement.parentNode.classList.contains("js-menuitem-with-nested-dropdown")) {
						event.stopPropagation();
						event.preventDefault();
					}

					if (document.activeElement.parentNode.classList.contains("navigation__menuitem--active")) {
						closeDropdownMenus();
						return;
					}

					if (document.activeElement.parentNode.classList.contains("dropdown__menuitem--active")) {
						closeNestedDropdownMenus();
						return;
					}

					if (document.activeElement.parentNode.classList.contains("js-first-level")) {
						closeDropdownMenus();
					}

					if (document.activeElement.classList.contains("js-open-dropdown-on-key")) {
						document.activeElement.parentNode.classList.add("navigation__menuitem--active"); // Show the menu by adding the appropriate class.
						return;
					}

					if (document.activeElement.parentNode.classList.contains("js-menuitem-with-nested-dropdown")) {
						document.activeElement.parentNode.classList.add("dropdown__menuitem--active");
						addEdgeToDropdown(document.activeElement.parentNode);
						return;
					}

				}
			});
		}

		alreadySetUpKeyEvents = true;

	}

	return {
		setUpAriaExpansion: setUpAriaExpansion,
		setUpAccessibleNavigationMenus: setUpAccessibleNavigationMenus,
		focusOnElement: focusOnElement
	}

}());

WAU.Sections = (function() {
	document.querySelectorAll('[data-section-type]').forEach(function(container) {

		let callback = (entries, observer) => {
			entries.forEach(entry => {
				if ( entry.isIntersecting ) {
					loadAssets(container);
					if (container.hasAttribute('data-section-loaded') ) {
						container.setAttribute('data-section-loaded', 'true');
					}
				}
			});
		};

		let observer = new IntersectionObserver(callback);
		observer.observe(container);

		function loadAssets (container) {
			// Load section assets
			if ( container.dataset.assetUrl ) {
				const loader = new WAU.Helpers.scriptLoader();
				loader.load([container.dataset.assetUrl]).then(({length}) => {
					// console.log(container.dataset.sectionType + ' script loaded');
				});
			}
		}

		document.addEventListener('shopify:section:select', function(event){
			if ( container.dataset.sectionId == event.detail.sectionId ) {
				if (container.hasAttribute('data-section-loaded') ) {
					event.target.classList.add('section--reloaded');
				}
			}
		});
		document.addEventListener('shopify:section:load', function(event){
      loadAssets(event.target.querySelector('[data-section-type]'));
			event.target.classList.add('section--reloaded');
		});

	});
})();

WAU.ProductGridVideo = {
	init: function init() {
		document.querySelectorAll('.js-bg-video-wrapper').forEach(function(element){
			WAU.ProductGridVideo.initVideo(element);
		});
	},
	initVideo: function initVideo(element) {
		var selectorId = element.dataset.productId,
				videoUrl = element.dataset.videoUrl,
				selector = '.js-bg-video-' + selectorId;

		var options = {
			mp4: videoUrl,
		}
		var instance = new vidbg(selector, options);

		var vid = selector + ' video',
				vid = document.querySelector(vid);
		vid.muted = true;

		document.addEventListener("shopify:section:unload", function(event) {
			WAU.ProductGridVideo.destroyVideo(instance);
		});
		document.addEventListener("shopify:section:select", function(event) {
			WAU.ProductGridVideo.reinitVideo(selector, options);
		});

	},
	destroyVideo: function destroyVideo(element) {
		element.destroy();
	},
	reinitVideo: function reinitVideo(selector, options) {
		var instance = new vidbg(selector, options);
		return instance;
	}
}

WAU.LocalizationForm = function(container) {
  function init() {
    container.querySelector('button').addEventListener('click', openSelector);
    container.querySelector('button').addEventListener('focusout', closeSelector);
    container.addEventListener('keyup', onContainerKeyUp);
    container.querySelectorAll('a').forEach(item => item.addEventListener('click', onItemClick));
  }
  function hidePanel() {
    container.querySelector('button').setAttribute('aria-expanded', 'false');
    container.querySelector('ul').setAttribute('hidden', true);
  }
  function onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    hidePanel();
    container.querySelector('button').focus();
  }
  function onItemClick(event) {
    event.preventDefault();
    const form = container.querySelector('form');
    container.querySelector('input[name="locale_code"], input[name="country_code"]').value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
  function openSelector() {
    container.querySelector('button').focus();
    container.querySelector('ul').toggleAttribute('hidden');
    container.querySelector('button').setAttribute('aria-expanded', (container.querySelector('button').getAttribute('aria-expanded') === 'false').toString());
  }
  function closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      hidePanel();
    }
  }

  return init();
}

/*============================================================================
 Shopify Common
==============================================================================*/

if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

/*============================================================================
  Global Events & Helpers
==============================================================================*/
(function WAUInits() {
	WAU.Accordion.init();
  WAU.Helpers.lazyLoad('.lazy', true);

  document.querySelectorAll('[data-localization-form]').forEach(function(container){
    WAU.LocalizationForm(container);
  });


	document.addEventListener('DOMContentLoaded', function() {
		if ( document.querySelectorAll('.js-bg-video-wrapper') ) {
			WAU.ProductGridVideo.init();
		}
	});

	document.addEventListener('shopify:section:select', function(event){
		if ( document.querySelectorAll('.js-bg-video-wrapper') ) {
			WAU.ProductGridVideo.init();
		}
    if ( event.target.querySelector('[data-localization-form]') ) {
      WAU.LocalizationForm(event.target.querySelector('[data-localization-form]'));
    }
    WAU.Helpers.lazyLoad('.lazy', true);
	});
})();

(function helperRteFormat() {
  WAU.Helpers.wrapIframe({
		iframes: document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]'),
    iframeWrapperClass: 'video-wrapper'
  });

	WAU.Helpers.wrapIframe({
		iframes: document.querySelectorAll('.rte iframe[src*="player.vimeo"]'),
		iframeWrapperClass: 'video-wrapper'
	});

  WAU.Helpers.wrapTable({
		tables: document.querySelectorAll('.rte table'),
    tableWrapperClass: 'table-wrapper'
  });
})();

(function helperThemeVersion() {
  /* Log Theme Version */
  log = function() {
      var args = Array.prototype.slice.call(arguments);
      args.unshift(console);
      return Function.prototype.bind.apply(console.log, args);
  }

  log("Foodie Version 3.0.1 by Underground", {bar: 1})();
})();

(function initModals() {

	if ( document.querySelector('[data-wau-modal="new-address"]') ) {
		WAU.Modal.init("new-address");
	}

	var buildModals = document.querySelectorAll('[data-wau-modal-content]');
	if ( buildModals ) {
		buildModals.forEach((item, i) => {
			var contentType = item.dataset.wauModalContent;
		});
	}

	var modals = document.querySelectorAll('[data-wau-modal]');
	if ( modals ) {
		modals.forEach((item, i) => {
			if (item.dataset.wauModal.includes("edit-address")) {
				WAU.Modal.init(item.dataset.wauModal);
			}
		});
	}

})();

(function formValidation() {
	/* Form Validation */
	var validateForm = function(submitEvent) {
	  if (!submitEvent.target.checkValidity()) {
	    submitEvent.preventDefault();
	    submitEvent.stopImmediatePropagation();
	    submitEvent.stopPropagation();

	    var form = submitEvent.target,
	        elements = form.elements;

	     for (var index = 0, len = elements.length; index < len; index++) {
	      var element = elements[index];
	      if (element.willValidate === true && element.validity.valid !== true) {
	        var message = element.validationMessage,
	            parent  = element.parentNode,
                existingMessage = parent.querySelector('small.validation-message'),
	            div     = document.createElement('small');
           
          if(element.id == "email-address"){
              div.appendChild(document.createTextNode('Please enter valid email address.'));
          } else {
    	      div.appendChild(document.createTextNode(message));
          }
	       div.classList.add('validation-message');

            if(existingMessage) {
              parent.removeChild(existingMessage);
            }
    	    parent.appendChild(div);
          

	       element.focus();
	       break;
	     }
	    }
	  } else {
	    return true;
	  }
	};

	document.addEventListener('DOMContentLoaded', function() {
	  var forms = document.querySelectorAll('form');

	  for (var index = forms.length - 1; index >= 0; index--) {
	    var form = forms[index];

	    form.noValidate = true;
	    form.addEventListener('submit', validateForm);
	  }
	});
})();

// --- UTM Parameter Persistence Script ---
(function() {
  // Configuration
  var UTM_CONFIG = {
    useLocalStorage: true,       // Use localStorage instead of sessionStorage for persistence across browser sessions
    storageKey: 'persistedUTM',  // Storage key for UTM parameters
    debug: false,                // Set to true to enable console debugging
    expireDays: 30,              // Number of days until UTM parameters expire (for localStorage)
    alwaysUseStoredParams: true, // Always use stored params even when new UTMs are not in URL
    keepExistingParams: true     // Keep existing UTM params in links that already have them
  };
  
  // Add error handling and debugging
  function logUTM(message, data) {
    if (UTM_CONFIG.debug) {
      console.log('[UTM Debug]', message, data);
    }
  }

  function getUTMParamsFromURL(url) {
    try {
      var params = {};
      var parser = document.createElement('a');
      parser.href = url;
      var query = parser.search.substring(1);
      if (!query) return params;
      
      query.split('&').forEach(function(part) {
        var item = part.split('=');
        if (item[0] && item[0].toLowerCase().startsWith('utm_')) {
          params[item[0]] = item[1] ? decodeURIComponent(item[1]) : '';
        }
      });
      
      logUTM('Extracted UTM params:', params);
      return params;
    } catch (error) {
      logUTM('Error extracting UTM params:', error);
      return {};
    }
  }

  function serializeUTMParams(params) {
    try {
      if (!params || typeof params !== 'object') return '';
      
      var result = Object.keys(params)
        .filter(function(key) {
          return params[key] && params[key].toString().trim() !== '';
        })
        .map(function(key) {
          return key + '=' + encodeURIComponent(params[key]);
        })
        .join('&');
      
      logUTM('Serialized UTM string:', result);
      return result;
    } catch (error) {
      logUTM('Error serializing UTM params:', error);
      return '';
    }
  }

  function isInternalLink(link) {
    try {
      if (!link || !link.href) return false;
      
      // Only rewrite links that are same-origin and not special links
      return (
        link.hostname === window.location.hostname &&
        !link.href.startsWith('javascript:') &&
        !link.href.startsWith('mailto:') &&
        !link.href.startsWith('tel:') &&
        link.href.indexOf('#') !== (link.href.length - 1) && // Allow anchors in the middle of URL
        !link.pathname.startsWith('/admin') &&
        !link.hasAttribute('data-no-utm') // Add ability to exclude specific links
      );
    } catch (error) {
      logUTM('Error checking internal link:', error);
      return false;
    }
  }

  function hasUTMParams(url) {
    return /[?&]utm_/.test(url);
  }

  function mergeUTMParams(existingParams, newParams) {
    var result = {};
    // Copy existing params first
    if (existingParams && typeof existingParams === 'object') {
      for (var key in existingParams) {
        if (existingParams.hasOwnProperty(key)) {
          result[key] = existingParams[key];
        }
      }
    }
    // Add/override with new params
    if (newParams && typeof newParams === 'object') {
      for (var key in newParams) {
        if (newParams.hasOwnProperty(key)) {
          result[key] = newParams[key];
        }
      }
    }
    return result;
  }

  function appendUTMParamsToURL(url, utmString) {
    if (!utmString) return url;
    
    try {
      var parts = url.split('#');
      var base = parts[0];
      var hash = parts.length > 1 ? '#' + parts.slice(1).join('#') : '';
      
      // If we have existing UTM params and want to keep them
      if (UTM_CONFIG.keepExistingParams && hasUTMParams(base)) {
        var existingUTMs = getUTMParamsFromURL(base);
        var newUTMs = {};
        
        // Parse the new UTM string into an object
        utmString.split('&').forEach(function(part) {
          var item = part.split('=');
          if (item[0] && item[1]) {
            newUTMs[item[0]] = decodeURIComponent(item[1]);
          }
        });
        
        // Merge UTMs, keeping existing ones if not in the new set
        var mergedUTMs = mergeUTMParams(existingUTMs, newUTMs);
        utmString = serializeUTMParams(mergedUTMs);
        
        // Remove existing UTMs from URL
        base = base.replace(/([?&])utm_[^=&]+=[^&]*/g, function(match, separator) {
          return separator === '?' && match.indexOf('&') === -1 ? '?' : '';
        }).replace(/\?&/, '?').replace(/&&/g, '&').replace(/[?&]$/g, '');
      }
      
      if (base.indexOf('?') === -1) {
        return base + '?' + utmString + hash;
      } else {
        if (base.charAt(base.length - 1) === '?' || base.charAt(base.length - 1) === '&') {
          return base + utmString + hash;
        } else {
          return base + '&' + utmString + hash;
        }
      }
    } catch (error) {
      logUTM('Error appending UTM to URL:', error);
      return url;
    }
  }

  // Function to update all internal links with UTM parameters
  function updateLinksWithUTM(utmString) {
    // Only add UTM parameters to links if current URL has UTM parameters
    if (window.location.href.indexOf('utm_') === -1) {
      // Don't modify URLs on direct visits
      return;
    }

    try {
      // Find all links on the page
      document.querySelectorAll('a').forEach(function(link) {
        // Only process internal links that don't already have UTM parameters
        if (link.href && isInternalLink(link.href) && !hasUTMParams(link.href)) {
          link.href = appendUTMParamsToURL(link.href, utmString);
        }
      });
    } catch (error) {
      logUTM('Error updating links with UTM parameters:', error);
    }
  }

  function handleDynamicContent() {
    // Use MutationObserver to handle dynamically added content
    if (window.MutationObserver) {
      var observer = new MutationObserver(function(mutations) {
        var shouldUpdate = false;
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach(function(node) {
              if (node.nodeType === 1 && (node.tagName === 'A' || (node.querySelectorAll && node.querySelector('a')))) {
                shouldUpdate = true;
              }
            });
          }
        });
        
        if (shouldUpdate) {
          var storedUTMString = getStoredUTMString();
          if (storedUTMString) {
            updateLinksWithUTM(storedUTMString);
          }
        }
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      
      logUTM('MutationObserver initialized for dynamic content');
    }
  }

  function getStorage() {
    return UTM_CONFIG.useLocalStorage ? localStorage : sessionStorage;
  }

  function storeUTMParams(params) {
    if (!params || Object.keys(params).length === 0) return false;
    
    try {
      var storage = getStorage();
      var data = {
        params: params,
        timestamp: new Date().getTime()
      };
      
      storage.setItem(UTM_CONFIG.storageKey, JSON.stringify(data));
      return true;
    } catch (error) {
      logUTM('Error storing UTM params:', error);
      return false;
    }
  }

  function retrieveUTMParams() {
    try {
      var storage = getStorage();
      var data = storage.getItem(UTM_CONFIG.storageKey);
      
      if (!data) return null;
      
      var parsedData = JSON.parse(data);
      
      // Check expiration if using localStorage
      if (UTM_CONFIG.useLocalStorage && parsedData.timestamp) {
        var now = new Date().getTime();
        var expireTime = UTM_CONFIG.expireDays * 24 * 60 * 60 * 1000;
        if ((now - parsedData.timestamp) > expireTime) {
          storage.removeItem(UTM_CONFIG.storageKey);
          return null;
        }
      }
      
      return parsedData.params;
    } catch (error) {
      logUTM('Error retrieving UTM params:', error);
      return null;
    }
  }

  function getStoredUTMString() {
    var params = retrieveUTMParams();
    return params ? serializeUTMParams(params) : '';
  }

  function clearStoredUTM() {
    try {
      getStorage().removeItem(UTM_CONFIG.storageKey);
      return true;
    } catch (error) {
      logUTM('Error clearing UTM params:', error);
      return false;
    }
  }

  // Enhanced function to store UTM parameters as cart attributes
  function storeCartAttributes(utmString) {
    if (!utmString) return;
    
    try {
      // Parse UTM string into an object
      var utmParams = {};
      utmString.split('&').forEach(function(param) {
        var parts = param.split('=');
        if (parts.length === 2) {
          utmParams[parts[0]] = decodeURIComponent(parts[1]);
        }
      });
      
      // Store UTM params as cart attributes using Shopify AJAX API
      if (typeof WAU !== 'undefined' && WAU.ThemeCart && WAU.ThemeCart.updateAttributes) {
        WAU.ThemeCart.getAttributes().then(function(attributes) {
          // Add UTM parameters to attributes
          for (var key in utmParams) {
            attributes[key] = utmParams[key];
          }
          
          // Add special 'influencer' attribute if utm_source is present
          if (utmParams['utm_source']) {
            attributes['influencer'] = utmParams['utm_source'];
            attributes['utm_detected'] = 'true';
          }
          
          // Update cart attributes
          WAU.ThemeCart.updateAttributes(attributes).then(function() {
            logUTM('Stored UTM parameters as cart attributes', attributes);
          });
        });
      }
    } catch (error) {
      logUTM('Error storing UTM parameters as cart attributes', error);
    }
  }

  // Function to ensure UTM parameters are passed to checkout
  function passUtmsToCheckout() {
    // Only run if user originally had UTMs
    if (localStorage.getItem('utm_origin_present') !== 'true') return;

    var storedUTMString = window.getStoredUTMString ? window.getStoredUTMString() : null;
    if (!storedUTMString) return;
    
    // Parse UTM parameters
    var utmParams = {};
    storedUTMString.split('&').forEach(function(param) {
      var parts = param.split('=');
      if (parts.length === 2 && parts[0].startsWith('utm_')) {
        utmParams[parts[0]] = decodeURIComponent(parts[1]);
      }
    });
    
    // No UTM parameters found
    if (Object.keys(utmParams).length === 0) return;

    // APPROACH 1: Add UTM parameters to cart attributes
    if (window.storeCartAttributes && typeof window.storeCartAttributes === 'function') {
      try {
        window.storeCartAttributes(storedUTMString);
        console.log('Stored UTM parameters in cart attributes');
      } catch (e) {
        console.log('Failed to store UTM parameters in cart attributes', e);
      }
    }
    
    // APPROACH 2: Handle checkout forms (add hidden inputs)
    try {
      document.querySelectorAll('form[action*="/cart"][action*="checkout"], form[action*="checkout"]').forEach(function(form) {
        // First check if form already has UTM hidden inputs
        var hasUtmInputs = false;
        form.querySelectorAll('input[name^="checkout[attributes][utm_"]').forEach(function() {
          hasUtmInputs = true;
        });
        
        if (!hasUtmInputs) {
          for (var key in utmParams) {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'checkout[attributes][' + key + ']';
            input.value = utmParams[key];
            form.appendChild(input);
          }
          console.log('Added UTM parameters to checkout form');
        }
      });
    } catch (e) {
      console.log('Error adding UTM parameters to checkout form', e);
    }

    // APPROACH 3: Update checkout links with UTM parameters
    try {
      document.querySelectorAll('a[href*="checkout"], [name="checkout"], .checkout-button').forEach(function(link) {
        if (link.tagName === 'A' && link.href && !link.href.includes('utm_') && window.appendUTMParamsToURL) {
          link.href = window.appendUTMParamsToURL(link.href, storedUTMString);
          console.log('Updated checkout link with UTM parameters:', link.href);
        }
      });
      console.log('Updated checkout links with UTM parameters');
    } catch (e) {
      console.log('Error updating checkout links with UTM parameters', e);
    }
    
    // APPROACH 4: Handle Shopify's native checkout buttons
    try {
      document.querySelectorAll('[data-shopify="payment-button"], .shopify-payment-button__button').forEach(function(button) {
        button.addEventListener('click', function(e) {
          // Store UTMs in cart attributes before checkout
          if (window.storeCartAttributes && storedUTMString) {
            window.storeCartAttributes(storedUTMString);
          }
        });
      });
    } catch (e) {
      console.log('Error handling Shopify payment buttons', e);
    }
  }

  // Function to initialize UTM parameter persistence
  function initUTMPersistence() {
    // Only process UTMs once per page load
    if (utmProcessedThisPageLoad) {
      return;
    }
    
    // Check if current URL has UTM parameters OR if we have stored UTM parameters
    var hasUrlUtms = hasUtmInCurrentUrl();
    var hasStoredUtms = false;
    
    // Check if we have stored UTM parameters
    if (window.getStoredUTMString && typeof window.getStoredUTMString === 'function') {
      var storedUTMString = window.getStoredUTMString();
      hasStoredUtms = storedUTMString && storedUTMString.length > 0;
    }
    
    if (!hasUrlUtms && !hasStoredUtms) {
      console.log('No UTM parameters in current URL or stored - not processing UTMs');
      return;
    }
    
    // Mark that we've processed UTMs on this page load
    utmProcessedThisPageLoad = true;
    
    // Get UTM parameters from URL or stored
    var urlParams = {};
    if (hasUrlUtms) {
      urlParams = getUTMParamsFromURL(window.location.href);
    } else if (hasStoredUtms) {
      // Parse stored UTM string back to params
      var storedUTMString = window.getStoredUTMString();
      storedUTMString.split('&').forEach(function(param) {
        var parts = param.split('=');
        if (parts.length === 2 && parts[0].startsWith('utm_')) {
          urlParams[parts[0]] = decodeURIComponent(parts[1]);
        }
      });
    }
    
    var hasUtmParams = Object.keys(urlParams).length > 0;
    
    // If we have UTM parameters, store them
    if (hasUtmParams) {
      // Mark that this user arrived via a campaign
      localStorage.setItem('utm_origin_present', 'true');
      
      // Store UTM parameters
      storeUTMParams(urlParams);
      
      // Store UTM parameters as cart attributes for checkout
      var utmString = serializeUTMParams(urlParams);
      if (utmString && window.storeCartAttributes && typeof window.storeCartAttributes === 'function') {
        storeCartAttributes(utmString);
      }
      
      console.log('UTM parameters processed and stored:', urlParams);
    }
    
    // Expose functions to global scope
    window.initUTMPersistence = initUTMPersistence;
    window.storeCartAttributes = storeCartAttributes;
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUTMPersistence);
  } else {
    initUTMPersistence();
  }

  // Handle navigation events (for SPA-like behavior)
  window.addEventListener('popstate', function() {
    setTimeout(initUTMPersistence, 100);
  });
  
  // Handle pushState and replaceState for SPAs
  var originalPushState = history.pushState;
  var originalReplaceState = history.replaceState;
  
  history.pushState = function() {
    originalPushState.apply(this, arguments);
    setTimeout(initUTMPersistence, 100);
  };
  
  history.replaceState = function() {
    originalReplaceState.apply(this, arguments);
    setTimeout(initUTMPersistence, 100);
  };

  // Expose public API for debugging and manual control
  window.utmPersistence = {
    init: initUTMPersistence,
    getParams: retrieveUTMParams,
    clearParams: clearStoredUTM,
    setDebug: function(enabled) {
      UTM_CONFIG.debug = enabled;
    },
    updateLinks: function() {
      var utmString = getStoredUTMString();
      if (utmString) updateLinksWithUTM(utmString);
    },
    getStorageType: function() {
      return UTM_CONFIG.useLocalStorage ? 'localStorage' : 'sessionStorage';
    },
    setStorageType: function(useLocalStorage) {
      // Transfer existing data if changing storage type
      var currentParams = retrieveUTMParams();
      UTM_CONFIG.useLocalStorage = !!useLocalStorage;
      if (currentParams) storeUTMParams(currentParams);
    },
    config: UTM_CONFIG
  };

  // Expose functions globally for use in other scripts
  window.getStoredUTMString = getStoredUTMString;
  window.getUTMParamsFromURL = getUTMParamsFromURL;
  window.serializeUTMParams = serializeUTMParams;
  window.appendUTMParamsToURL = appendUTMParamsToURL;
  window.storeCartAttributes = storeCartAttributes;
  window.initUTMPersistence = initUTMPersistence;
  window.passUtmsToCheckout = passUtmsToCheckout;
})();
// --- End UTM Parameter Persistence Script ---

// Check if current URL has UTM parameters
function hasUtmInCurrentUrl() {
  var currentUrl = window.location.href;
  return currentUrl.indexOf('utm_source=') !== -1 || 
         currentUrl.indexOf('utm_medium=') !== -1 || 
         currentUrl.indexOf('utm_campaign=') !== -1;
}

// Flag to track if this page load already processed UTMs
var utmProcessedThisPageLoad = false;

// Function to initialize UTM parameter persistence
function initUTMPersistence() {
  // Only process UTMs once per page load
  if (utmProcessedThisPageLoad) {
    return;
  }
  
  // Check if current URL has UTM parameters OR if we have stored UTM parameters
  var hasUrlUtms = hasUtmInCurrentUrl();
  var hasStoredUtms = false;
  
  // Check if we have stored UTM parameters
  if (window.getStoredUTMString && typeof window.getStoredUTMString === 'function') {
    var storedUTMString = window.getStoredUTMString();
    hasStoredUtms = storedUTMString && storedUTMString.length > 0;
  }
  
  if (!hasUrlUtms && !hasStoredUtms) {
    console.log('No UTM parameters in current URL or stored - not processing UTMs');
    return;
  }
  
  // Mark that we've processed UTMs on this page load
  utmProcessedThisPageLoad = true;
  
  // Get UTM parameters from URL or stored
  var urlParams = {};
  if (hasUrlUtms) {
    urlParams = getUTMParamsFromURL(window.location.href);
  } else if (hasStoredUtms) {
    // Parse stored UTM string back to params
    var storedUTMString = window.getStoredUTMString();
    storedUTMString.split('&').forEach(function(param) {
      var parts = param.split('=');
      if (parts.length === 2 && parts[0].startsWith('utm_')) {
        urlParams[parts[0]] = decodeURIComponent(parts[1]);
      }
    });
  }
  
  var hasUtmParams = Object.keys(urlParams).length > 0;
  
  // If we have UTM parameters, store them
  if (hasUtmParams) {
    // Mark that this user arrived via a campaign
    localStorage.setItem('utm_origin_present', 'true');
    
    // Store UTM parameters
    storeUTMParams(urlParams);
    
    // Store UTM parameters as cart attributes for checkout
    var utmString = serializeUTMParams(urlParams);
    if (utmString && window.storeCartAttributes && typeof window.storeCartAttributes === 'function') {
      storeCartAttributes(utmString);
    }
    
    console.log('UTM parameters processed and stored:', urlParams);
  }
  
  // Expose functions to global scope
  window.initUTMPersistence = initUTMPersistence;
  window.storeCartAttributes = storeCartAttributes;
}

// Function to add UTM parameters to URL if they're missing but stored
function addUtmsToCurrentUrl() {
  // DISABLED: We're no longer modifying the current URL as it causes checkout issues
  return;
}

// Function to ensure UTM parameters are passed to checkout
function passUtmsToCheckout() {
  // Only run if user originally had UTMs
  if (localStorage.getItem('utm_origin_present') !== 'true') return;

  var storedUTMString = window.getStoredUTMString ? window.getStoredUTMString() : null;
  if (!storedUTMString) return;
  
  // Parse UTM parameters
  var utmParams = {};
  storedUTMString.split('&').forEach(function(param) {
    var parts = param.split('=');
    if (parts.length === 2 && parts[0].startsWith('utm_')) {
      utmParams[parts[0]] = decodeURIComponent(parts[1]);
    }
  });
  
  // No UTM parameters found
  if (Object.keys(utmParams).length === 0) return;

  // APPROACH 1: Add UTM parameters to cart attributes
  if (window.storeCartAttributes && typeof window.storeCartAttributes === 'function') {
    try {
      window.storeCartAttributes(storedUTMString);
      console.log('Stored UTM parameters in cart attributes');
    } catch (e) {
      console.log('Failed to store UTM parameters in cart attributes', e);
    }
  }
  
  // APPROACH 2: Handle checkout forms (add hidden inputs)
  try {
    document.querySelectorAll('form[action*="/cart"][action*="checkout"], form[action*="checkout"]').forEach(function(form) {
      // First check if form already has UTM hidden inputs
      var hasUtmInputs = false;
      form.querySelectorAll('input[name^="checkout[attributes][utm_"]').forEach(function() {
        hasUtmInputs = true;
      });
      
      if (!hasUtmInputs) {
        for (var key in utmParams) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'checkout[attributes][' + key + ']';
          input.value = utmParams[key];
          form.appendChild(input);
        }
        console.log('Added UTM parameters to checkout form');
      }
    });
  } catch (e) {
    console.log('Error adding UTM parameters to checkout form', e);
  }

  // APPROACH 3: Update checkout links with UTM parameters
  try {
    document.querySelectorAll('a[href*="checkout"], [name="checkout"], .checkout-button').forEach(function(link) {
      if (link.tagName === 'A' && link.href && !link.href.includes('utm_') && window.appendUTMParamsToURL) {
        link.href = window.appendUTMParamsToURL(link.href, storedUTMString);
        console.log('Updated checkout link with UTM parameters:', link.href);
      }
    });
    console.log('Updated checkout links with UTM parameters');
  } catch (e) {
    console.log('Error updating checkout links with UTM parameters', e);
  }
  
  // APPROACH 4: Handle Shopify's native checkout buttons
  try {
    document.querySelectorAll('[data-shopify="payment-button"], .shopify-payment-button__button').forEach(function(button) {
      button.addEventListener('click', function(e) {
        // Store UTMs in cart attributes before checkout
        if (window.storeCartAttributes && storedUTMString) {
          window.storeCartAttributes(storedUTMString);
        }
      });
    });
  } catch (e) {
    console.log('Error handling Shopify payment buttons', e);
  }
}

// Function to set up analytics with UTM parameters
function setupAnalyticsWithUTMs() {
  // Only run if current URL has UTM parameters and we haven't processed UTMs yet
  if (!hasUtmInCurrentUrl() || utmProcessedThisPageLoad) return;
  
  // Mark that we've processed UTMs on this page load
  utmProcessedThisPageLoad = true;

  // Get UTM parameters directly from URL
  var urlParams = getUTMParamsFromURL(window.location.href);
  if (!urlParams || Object.keys(urlParams).length === 0) return;

  // Track influencer source if available
  if (urlParams['utm_source']) {
    console.log('Tracking influencer: ' + urlParams['utm_source'] + ' - one time only');
  }

  // Set up Google Analytics with UTM parameters
  setTimeout(function() {
    try {
      if (typeof ga === 'function') {
        // Set the raw UTM parameters
        for (var key in urlParams) {
          ga('set', key, urlParams[key]);
        }
        
        // Set custom dimensions for influencer tracking
        if (urlParams['utm_source']) ga('set', 'dimension1', urlParams['utm_source']);
        if (urlParams['utm_medium']) ga('set', 'dimension2', urlParams['utm_medium']);
        if (urlParams['utm_campaign']) ga('set', 'dimension3', urlParams['utm_campaign']);
        if (urlParams['utm_content']) ga('set', 'dimension4', urlParams['utm_content']);
        if (urlParams['utm_term']) ga('set', 'dimension5', urlParams['utm_term']);
        
        // Send an influencer page view event
        if (urlParams['utm_source']) {
          ga('send', 'event', 'Influencer', 'Page View', urlParams['utm_source']);
        }
        
        console.log('Enhanced Google Analytics with influencer tracking - one time only');
      }
    } catch (e) {
      console.log('Error setting Google Analytics parameters', e);
    }
  }, 2000);

  // Set up Facebook Pixel with UTM parameters
  setTimeout(function() {
    try {
      // Check if fbq is defined and is a function
      if (window.fbq && typeof window.fbq === 'function') {
        // Track a custom event with UTM parameters for influencer tracking
        window.fbq('trackCustom', 'InfluencerVisit', urlParams);
        console.log('Enhanced Facebook Pixel with influencer tracking - one time only');
      }
    } catch (e) {
      console.log('Facebook Pixel not available', e);
    }
  }, 3000); // Longer timeout for Facebook Pixel
}

// Call on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
  // Initialize UTM persistence (storage only, no DOM modification)
  // This will only run if UTM parameters are in the current URL
  if (window.initUTMPersistence && typeof window.initUTMPersistence === 'function') {
    window.initUTMPersistence();
  }
  
  // Set up analytics with UTMs - only if UTMs are in current URL
  if (hasUtmInCurrentUrl()) {
    setupAnalyticsWithUTMs();
  }
  
  // Enhanced checkout handling for cart page
  if (window.location.pathname.includes('/cart')) {
    setTimeout(function() {
      var checkoutButtons = document.querySelectorAll('[name="checkout"], .checkout-button');
      
      if (checkoutButtons.length > 0 && 
          window.getStoredUTMString && 
          typeof window.getStoredUTMString === 'function') {
        
        var storedUTMString = window.getStoredUTMString();
        
        checkoutButtons.forEach(function(button) {
          button.addEventListener('click', function(e) {
            // Store UTMs in cart attributes
            if (window.storeCartAttributes && 
                typeof window.storeCartAttributes === 'function' && 
                storedUTMString) {
              
              window.storeCartAttributes(storedUTMString);
            }
          });
        });
      }
    }, 1000);
  }
  
  // Enhanced checkout form handling
  if (window.location.pathname.includes('/cart')) {
    setTimeout(function() {
      // Handle checkout forms
      document.querySelectorAll('form[action*="checkout"]').forEach(function(form) {
        form.addEventListener('submit', function(e) {
          var storedUTMString = window.getStoredUTMString ? window.getStoredUTMString() : '';
          if (storedUTMString) {
            // Parse UTM parameters
            var utmParams = {};
            storedUTMString.split('&').forEach(function(param) {
              var parts = param.split('=');
              if (parts.length === 2 && parts[0].startsWith('utm_')) {
                utmParams[parts[0]] = decodeURIComponent(parts[1]);
              }
            });
            
            // Add UTM parameters as hidden inputs to the form
            for (var key in utmParams) {
              var input = document.createElement('input');
              input.type = 'hidden';
              input.name = 'checkout[attributes][' + key + ']';
              input.value = utmParams[key];
              form.appendChild(input);
            }
            
            console.log('Added UTM parameters to checkout form submission');
          }
        });
      });
    }, 1000);
  }
  
  // Call enhanced checkout function for cart pages
  if (window.location.pathname.includes('/cart')) {
    setTimeout(function() {
      if (window.passUtmsToCheckout && typeof window.passUtmsToCheckout === 'function') {
        window.passUtmsToCheckout();
      }
    }, 1500);
  }
  
  // Global checkout enhancement - runs on all pages
  setTimeout(function() {
    enhanceCheckoutWithUTMs();
  }, 2000);
  
  // Handle Shopify's native checkout process
  setTimeout(function() {
    handleShopifyCheckout();
  }, 2500);
  
  // Enhance checkout URLs with UTM parameters
  setTimeout(function() {
    enhanceCheckoutURL();
  }, 3000);
  
  // Set up aggressive checkout URL interception
  setTimeout(function() {
    interceptCheckoutURLs();
  }, 1000);
  
  // Directly modify checkout links
  setTimeout(function() {
    modifyCheckoutLinks();
  }, 1500);
  
  // Handle Shopify checkout redirects
  setTimeout(function() {
    handleShopifyCheckoutRedirect();
  }, 2000);
});

// Comprehensive function to enhance checkout with UTM parameters on all pages
function enhanceCheckoutWithUTMs() {
  // Only run if user originally had UTMs
  if (localStorage.getItem('utm_origin_present') !== 'true') return;

  var storedUTMString = window.getStoredUTMString ? window.getStoredUTMString() : null;
  if (!storedUTMString) return;
  
  console.log('Enhancing checkout with UTM parameters globally');
  
  // Parse UTM parameters
  var utmParams = {};
  storedUTMString.split('&').forEach(function(param) {
    var parts = param.split('=');
    if (parts.length === 2 && parts[0].startsWith('utm_')) {
      utmParams[parts[0]] = decodeURIComponent(parts[1]);
    }
  });
  
  // No UTM parameters found
  if (Object.keys(utmParams).length === 0) return;

  // APPROACH 1: Update all checkout links and buttons
  try {
    var checkoutElements = document.querySelectorAll('a[href*="checkout"], [name="checkout"], .checkout-button, [data-shopify="payment-button"], .shopify-payment-button__button');
    
    checkoutElements.forEach(function(element) {
      // Handle regular links
      if (element.tagName === 'A' && element.href && !element.href.includes('utm_') && window.appendUTMParamsToURL) {
        element.href = window.appendUTMParamsToURL(element.href, storedUTMString);
        console.log('Updated checkout link with UTM parameters:', element.href);
      }
      
      // Add click handlers for buttons
      if (element.tagName !== 'A' || !element.href) {
        element.addEventListener('click', function(e) {
          // Store UTMs in cart attributes before checkout
          if (window.storeCartAttributes && storedUTMString) {
            window.storeCartAttributes(storedUTMString);
            console.log('Stored UTM parameters before checkout');
          }
        });
      }
    });
    
    console.log('Enhanced ' + checkoutElements.length + ' checkout elements with UTM parameters');
  } catch (e) {
    console.log('Error enhancing checkout elements:', e);
  }

  // APPROACH 2: Handle all checkout forms
  try {
    document.querySelectorAll('form[action*="checkout"]').forEach(function(form) {
      // Remove existing UTM inputs to avoid duplicates
      form.querySelectorAll('input[name^="checkout[attributes][utm_"]').forEach(function(input) {
        input.remove();
      });
      
      // Add UTM parameters as hidden inputs
      for (var key in utmParams) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'checkout[attributes][' + key + ']';
        input.value = utmParams[key];
        form.appendChild(input);
      }
      
      console.log('Added UTM parameters to checkout form');
    });
  } catch (e) {
    console.log('Error adding UTM parameters to checkout forms:', e);
  }

  // APPROACH 3: Store in cart attributes
  if (window.storeCartAttributes && typeof window.storeCartAttributes === 'function') {
    try {
      window.storeCartAttributes(storedUTMString);
      console.log('Stored UTM parameters in cart attributes globally');
    } catch (e) {
      console.log('Failed to store UTM parameters in cart attributes:', e);
    }
  }
  
  // APPROACH 4: Set up MutationObserver for dynamically added checkout elements
  setupCheckoutMutationObserver(storedUTMString, utmParams);
}

// Function to set up MutationObserver for dynamically added checkout elements
function setupCheckoutMutationObserver(storedUTMString, utmParams) {
  if (window.MutationObserver) {
    var observer = new MutationObserver(function(mutations) {
      var shouldEnhance = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              // Check if the added node is a checkout element
              if (node.matches && (node.matches('a[href*="checkout"]') || 
                  node.matches('[name="checkout"]') || 
                  node.matches('.checkout-button') ||
                  node.matches('[data-shopify="payment-button"]') ||
                  node.matches('.shopify-payment-button__button'))) {
                shouldEnhance = true;
              }
              
              // Check if the added node contains checkout elements
              if (node.querySelectorAll) {
                var checkoutElements = node.querySelectorAll('a[href*="checkout"], [name="checkout"], .checkout-button, [data-shopify="payment-button"], .shopify-payment-button__button');
                if (checkoutElements.length > 0) {
                  shouldEnhance = true;
                }
              }
            }
          });
        }
      });
      
      if (shouldEnhance && storedUTMString) {
        console.log('Enhancing dynamically added checkout elements with UTM parameters');
        
        // Enhance checkout links
        document.querySelectorAll('a[href*="checkout"]').forEach(function(link) {
          if (link.href && !link.href.includes('utm_') && window.appendUTMParamsToURL) {
            link.href = window.appendUTMParamsToURL(link.href, storedUTMString);
          }
        });
        
        // Enhance checkout buttons
        document.querySelectorAll('[name="checkout"], .checkout-button, [data-shopify="payment-button"], .shopify-payment-button__button').forEach(function(button) {
          if (!button.hasAttribute('data-utm-enhanced')) {
            button.setAttribute('data-utm-enhanced', 'true');
            button.addEventListener('click', function(e) {
              if (window.storeCartAttributes && storedUTMString) {
                window.storeCartAttributes(storedUTMString);
              }
            });
          }
        });
        
        // Enhance checkout forms
        document.querySelectorAll('form[action*="checkout"]').forEach(function(form) {
          if (!form.hasAttribute('data-utm-enhanced')) {
            form.setAttribute('data-utm-enhanced', 'true');
            
            // Remove existing UTM inputs
            form.querySelectorAll('input[name^="checkout[attributes][utm_"]').forEach(function(input) {
              input.remove();
            });
            
            // Add UTM parameters as hidden inputs
            for (var key in utmParams) {
              var input = document.createElement('input');
              input.type = 'hidden';
              input.name = 'checkout[attributes][' + key + ']';
              input.value = utmParams[key];
              form.appendChild(input);
            }
          }
        });
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    console.log('MutationObserver set up for dynamic checkout elements');
  }
}

// Flag to track if cart attributes already updated this page load
var cartAttributesUpdatedThisPageLoad = false;

// Function to store UTM parameters as cart attributes
function storeCartAttributes(utmString) {
  // Only store UTM parameters once per page load
  if (cartAttributesUpdatedThisPageLoad) {
    console.log('Cart attributes already updated this page load - skipping');
    return;
  }
  
  // Only store UTM parameters if present in the URL
  if (!hasUtmInCurrentUrl()) {
    console.log('No UTM parameters in current URL - not storing in cart attributes');
    return;
  }
  
  if (!utmString) return;
  
  // Mark that we've updated cart attributes on this page load
  cartAttributesUpdatedThisPageLoad = true;
  
  try {
    if (typeof WAU !== 'undefined' && WAU.ThemeCart && WAU.ThemeCart.updateAttributes) {
      // Parse UTM parameters from the UTM string
      var utmParams = {};
      utmString.split('&').forEach(function(param) {
        var parts = param.split('=');
        if (parts.length === 2 && parts[0].startsWith('utm_')) {
          utmParams[parts[0]] = decodeURIComponent(parts[1]);
        }
      });
      
      // Create cart attributes object
      var attributes = {};
      
      // Add UTM parameters to cart attributes
      for (var key in utmParams) {
        attributes[key] = utmParams[key];
      }
      
      // Add special 'influencer' attribute if utm_source is present
      if (utmParams['utm_source']) {
        attributes['influencer'] = utmParams['utm_source'];
        attributes['utm_detected'] = 'true'; // Flag to indicate this order came from a UTM source
      }
      
      // Update cart attributes
      WAU.ThemeCart.updateAttributes(attributes).then(function() {
        console.log('Cart attributes updated with UTM parameters - one time only');
      }).catch(function(error) {
        console.log('Error updating cart attributes:', error);
      });
    }
  } catch (error) {
    console.log('Error storing UTM parameters as cart attributes:', error);
  }
}

// Call on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
  // Check if URL has UTMs - ONLY process if UTMs are in the current page URL
  var currentUrl = window.location.href;
  var hasUtmsInUrl = currentUrl.indexOf('utm_source=') !== -1 || 
                    currentUrl.indexOf('utm_medium=') !== -1 || 
                    currentUrl.indexOf('utm_campaign=') !== -1;
                    
  if (!hasUtmsInUrl) {
    console.log('No UTM parameters in current URL - not processing UTMs');
    return;
  }
  
  console.log('UTM parameters detected in URL - processing ONE TIME ONLY');
  
  // Extract UTM parameters from URL
  var urlParams = getUTMParamsFromURL(window.location.href);
  if (!urlParams || Object.keys(urlParams).length === 0) return;
  
  // Create UTM string for appending to links
  var utmString = '';
  for (var key in urlParams) {
    utmString += (utmString ? '&' : '') + key + '=' + encodeURIComponent(urlParams[key]);
  }
  
  // Update all internal links with UTM parameters
  if (utmString) {
    console.log('Adding UTM parameters to internal links');
    document.querySelectorAll('a[href]').forEach(function(link) {
      // Only update internal links that don't already have UTMs
      if (link.href.indexOf(window.location.hostname) > -1 && 
          !link.href.includes('utm_') &&
          !link.href.includes('#') && 
          !link.href.includes('javascript:')) {
        
        // Add UTM parameters to link
        if (link.href.indexOf('?') > -1) {
          link.href = link.href + '&' + utmString;
        } else {
          link.href = link.href + '?' + utmString;
        }
      }
    });
  }
  
  // Get UTM parameters from URL and store in cart attributes
  try {
    // Create cart attributes for checkout tracking
    if (typeof WAU !== 'undefined' && WAU.ThemeCart && WAU.ThemeCart.updateAttributes) {
      // Create attributes object
      var attributes = {};
      
      // Add UTM parameters to attributes
      for (var key in urlParams) {
        attributes[key] = urlParams[key];
      }
      
      // Add special 'influencer' attribute if utm_source is present
      if (urlParams['utm_source']) {
        attributes['influencer'] = urlParams['utm_source'];
        attributes['utm_detected'] = 'true';
      }
      
      // Update cart attributes
      WAU.ThemeCart.updateAttributes(attributes).then(function() {
        console.log('Cart attributes updated with UTM parameters - ONE TIME ONLY');
      });
    }
    
    // Set up analytics - minimal version
    if (typeof ga === 'function' && urlParams['utm_source']) {
      setTimeout(function() {
        ga('send', 'event', 'Influencer', 'Visit', urlParams['utm_source']);
      }, 2000);
    }
  } catch (e) {
    console.log('Error processing UTM parameters:', e);
  }
});

// Function to track purchase conversions with UTM data
function trackPurchaseConversion(orderData) {
  try {
    // Get stored UTM parameters
    var storedUTMString = window.getStoredUTMString ? window.getStoredUTMString() : '';
    var utmParams = {};
    
    if (storedUTMString) {
      // Parse UTM parameters
      storedUTMString.split('&').forEach(function(param) {
        var parts = param.split('=');
        if (parts.length === 2 && parts[0].startsWith('utm_')) {
          utmParams[parts[0]] = decodeURIComponent(parts[1]);
        }
      });
    }
    
    // Only track if we have UTM parameters
    if (Object.keys(utmParams).length === 0) {
      console.log('No UTM parameters found - skipping purchase tracking');
      return;
    }
    
    console.log('Tracking purchase conversion with UTM data:', utmParams);
    
    // Track with Google Analytics
    if (typeof ga === 'function') {
      // Enhanced Ecommerce tracking
      ga('require', 'ec');
      
      // Add UTM parameters to transaction
      var transactionData = {
        'id': orderData.order_id || 'unknown',
        'affiliation': 'Online Store',
        'revenue': orderData.total_price || 0,
        'tax': orderData.total_tax || 0,
        'shipping': orderData.total_shipping || 0,
        'currency': orderData.currency || 'USD'
      };
      
      // Add UTM parameters as custom dimensions
      if (utmParams['utm_source']) ga('set', 'dimension1', utmParams['utm_source']);
      if (utmParams['utm_medium']) ga('set', 'dimension2', utmParams['utm_medium']);
      if (utmParams['utm_campaign']) ga('set', 'dimension3', utmParams['utm_campaign']);
      if (utmParams['utm_content']) ga('set', 'dimension4', utmParams['utm_content']);
      if (utmParams['utm_term']) ga('set', 'dimension5', utmParams['utm_term']);
      
      // Send transaction
      ga('ec:addTransaction', transactionData);
      ga('send', 'pageview');
      
      // Send purchase event
      ga('send', 'event', 'Ecommerce', 'Purchase', utmParams['utm_source'] || 'unknown', {
        'event_category': 'Purchase',
        'event_label': utmParams['utm_campaign'] || 'unknown',
        'value': orderData.total_price || 0,
        'non_interaction': true
      });
      
      console.log('Google Analytics purchase tracking completed');
    }
    
    // Track with Facebook Pixel
    if (typeof fbq === 'function') {
      var pixelData = {
        'content_name': 'Purchase',
        'content_category': 'Purchase',
        'value': orderData.total_price || 0,
        'currency': orderData.currency || 'USD',
        'utm_source': utmParams['utm_source'],
        'utm_medium': utmParams['utm_medium'],
        'utm_campaign': utmParams['utm_campaign'],
        'utm_content': utmParams['utm_content'],
        'utm_term': utmParams['utm_term']
      };
      
      fbq('track', 'Purchase', pixelData);
      console.log('Facebook Pixel purchase tracking completed');
    }
    
    // Store conversion data locally for reporting
    var conversionData = {
      'order_id': orderData.order_id,
      'total_price': orderData.total_price,
      'currency': orderData.currency,
      'utm_source': utmParams['utm_source'],
      'utm_medium': utmParams['utm_medium'],
      'utm_campaign': utmParams['utm_campaign'],
      'utm_content': utmParams['utm_content'],
      'utm_term': utmParams['utm_term'],
      'timestamp': new Date().toISOString()
    };
    
    // Store conversion data
    var conversions = JSON.parse(localStorage.getItem('utm_conversions') || '[]');
    conversions.push(conversionData);
    localStorage.setItem('utm_conversions', JSON.stringify(conversions));
    
    console.log('Purchase conversion tracked successfully');
    
  } catch (error) {
    console.log('Error tracking purchase conversion:', error);
  }
}

// Function to get conversion analytics
function getUTMConversionAnalytics() {
  try {
    var conversions = JSON.parse(localStorage.getItem('utm_conversions') || '[]');
    var analytics = {};
    
    conversions.forEach(function(conversion) {
      var source = conversion.utm_source || 'unknown';
      var medium = conversion.utm_medium || 'unknown';
      var campaign = conversion.utm_campaign || 'unknown';
      
      if (!analytics[source]) analytics[source] = {};
      if (!analytics[source][medium]) analytics[source][medium] = {};
      if (!analytics[source][medium][campaign]) {
        analytics[source][medium][campaign] = {
          'conversions': 0,
          'revenue': 0,
          'orders': []
        };
      }
      
      analytics[source][medium][campaign].conversions++;
      analytics[source][medium][campaign].revenue += parseFloat(conversion.total_price) || 0;
      analytics[source][medium][campaign].orders.push({
        'order_id': conversion.order_id,
        'revenue': conversion.total_price,
        'timestamp': conversion.timestamp
      });
    });
    
    return analytics;
  } catch (error) {
    console.log('Error getting UTM conversion analytics:', error);
    return {};
  }
}

// Function to clear conversion data
function clearUTMConversionData() {
  try {
    localStorage.removeItem('utm_conversions');
    console.log('UTM conversion data cleared');
  } catch (error) {
    console.log('Error clearing UTM conversion data:', error);
  }
}

// Function to automatically track purchase on checkout completion
function setupPurchaseTracking() {
  // Listen for checkout completion
  document.addEventListener('DOMContentLoaded', function() {
    // Check if we're on a thank you/order confirmation page
    if (window.location.pathname.includes('/thank_you') || 
        window.location.pathname.includes('/orders/') ||
        document.querySelector('[data-order-confirmation]')) {
      
      // Get order data from page
      var orderData = getOrderDataFromPage();
      
      if (orderData) {
        console.log('Order completion detected, tracking purchase...');
        trackPurchaseConversion(orderData);
      }
    }
  });
  
  // Listen for Shopify checkout completion events
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('[data-order-confirmation]')) {
      var orderData = getOrderDataFromPage();
      if (orderData) {
        console.log('Order completion detected via section load, tracking purchase...');
        trackPurchaseConversion(orderData);
      }
    }
  });
}

// Function to extract order data from the page
function getOrderDataFromPage() {
  try {
    var orderData = {};
    
    // Try to get order data from Shopify's order object
    if (typeof Shopify !== 'undefined' && Shopify.order) {
      orderData = {
        order_id: Shopify.order.order_number || Shopify.order.id,
        total_price: Shopify.order.total_price,
        currency: Shopify.order.currency,
        total_tax: Shopify.order.total_tax,
        total_shipping: Shopify.order.total_shipping
      };
    }
    
    // Try to get from order confirmation elements
    if (!orderData.order_id) {
      var orderNumberElement = document.querySelector('[data-order-number], .order-number, #order-number');
      if (orderNumberElement) {
        orderData.order_id = orderNumberElement.textContent.trim();
      }
    }
    
    if (!orderData.total_price) {
      var totalElement = document.querySelector('[data-order-total], .order-total, #order-total');
      if (totalElement) {
        var totalText = totalElement.textContent.trim();
        orderData.total_price = parseFloat(totalText.replace(/[^0-9.]/g, ''));
      }
    }
    
    // Default values if not found
    if (!orderData.order_id) orderData.order_id = 'unknown_' + Date.now();
    if (!orderData.total_price) orderData.total_price = 0;
    if (!orderData.currency) orderData.currency = 'USD';
    
    return orderData;
    
  } catch (error) {
    console.log('Error extracting order data:', error);
    return null;
  }
}

// Initialize purchase tracking
setupPurchaseTracking();

// Simple function to manually track a purchase (can be called from anywhere)
function trackPurchase(orderId, totalPrice, currency) {
  var orderData = {
    order_id: orderId,
    total_price: totalPrice,
    currency: currency || 'USD'
  };
  
  console.log('Manually tracking purchase:', orderData);
  trackPurchaseConversion(orderData);
}

// Expose manual tracking function
window.trackPurchase = trackPurchase;

// Function to display conversion analytics in console
function showConversionAnalytics() {
  var analytics = getUTMConversionAnalytics();
  
  console.log('=== UTM CONVERSION ANALYTICS ===');
  
  if (Object.keys(analytics).length === 0) {
    console.log('No conversion data found');
    return;
  }
  
  for (var source in analytics) {
    console.log('Source: ' + source);
    
    for (var medium in analytics[source]) {
      console.log('  Medium: ' + medium);
      
      for (var campaign in analytics[source][medium]) {
        var data = analytics[source][medium][campaign];
        console.log('    Campaign: ' + campaign);
        console.log('      Conversions: ' + data.conversions);
        console.log('      Revenue: $' + data.revenue.toFixed(2));
        console.log('      Average Order Value: $' + (data.revenue / data.conversions).toFixed(2));
        console.log('      Orders: ' + data.orders.length);
        console.log('');
      }
    }
  }
  
  // Calculate totals
  var totalConversions = 0;
  var totalRevenue = 0;
  
  for (var source in analytics) {
    for (var medium in analytics[source]) {
      for (var campaign in analytics[source][medium]) {
        var data = analytics[source][medium][campaign];
        totalConversions += data.conversions;
        totalRevenue += data.revenue;
      }
    }
  }
  
  console.log('=== TOTALS ===');
  console.log('Total Conversions: ' + totalConversions);
  console.log('Total Revenue: $' + totalRevenue.toFixed(2));
  console.log('==================');
}

// Expose analytics display function
window.showConversionAnalytics = showConversionAnalytics;

// Function to handle Shopify's native checkout process
function handleShopifyCheckout() {
  // Only run if user originally had UTMs
  if (localStorage.getItem('utm_origin_present') !== 'true') return;

  var storedUTMString = window.getStoredUTMString ? window.getStoredUTMString() : null;
  if (!storedUTMString) return;
  
  // Parse UTM parameters
  var utmParams = {};
  storedUTMString.split('&').forEach(function(param) {
    var parts = param.split('=');
    if (parts.length === 2 && parts[0].startsWith('utm_')) {
      utmParams[parts[0]] = decodeURIComponent(parts[1]);
    }
  });
  
  // No UTM parameters found
  if (Object.keys(utmParams).length === 0) return;

  // Handle Shopify's native checkout buttons
  try {
    // Shopify Payment Buttons
    document.querySelectorAll('[data-shopify="payment-button"], .shopify-payment-button__button').forEach(function(button) {
      if (!button.hasAttribute('data-utm-enhanced')) {
        button.setAttribute('data-utm-enhanced', 'true');
        
        button.addEventListener('click', function(e) {
          // Store UTMs in cart attributes before checkout
          if (window.storeCartAttributes && storedUTMString) {
            window.storeCartAttributes(storedUTMString);
            console.log('Stored UTM parameters before Shopify checkout');
          }
        });
      }
    });
    
    // Shopify's Buy Now buttons
    document.querySelectorAll('[data-shopify="payment-button"][data-testid="Checkout-button"]').forEach(function(button) {
      if (!button.hasAttribute('data-utm-enhanced')) {
        button.setAttribute('data-utm-enhanced', 'true');
        
        button.addEventListener('click', function(e) {
          // Store UTMs in cart attributes before checkout
          if (window.storeCartAttributes && storedUTMString) {
            window.storeCartAttributes(storedUTMString);
            console.log('Stored UTM parameters before Shopify Buy Now checkout');
          }
        });
      }
    });
    
    console.log('Enhanced Shopify checkout buttons with UTM parameters');
  } catch (e) {
    console.log('Error enhancing Shopify checkout buttons:', e);
  }
}

// Function to ensure UTM parameters are passed to checkout
function passUtmsToCheckout() {
  // Only run if user originally had UTMs
  if (localStorage.getItem('utm_origin_present') !== 'true') return;

  var storedUTMString = window.getStoredUTMString ? window.getStoredUTMString() : null;
  if (!storedUTMString) return;
  
  // Parse UTM parameters
  var utmParams = {};
  storedUTMString.split('&').forEach(function(param) {
    var parts = param.split('=');
    if (parts.length === 2 && parts[0].startsWith('utm_')) {
      utmParams[parts[0]] = decodeURIComponent(parts[1]);
    }
  });
  
  // No UTM parameters found
  if (Object.keys(utmParams).length === 0) return;

  // APPROACH 1: Add UTM parameters to cart attributes
  if (window.storeCartAttributes && typeof window.storeCartAttributes === 'function') {
    try {
      window.storeCartAttributes(storedUTMString);
      console.log('Stored UTM parameters in cart attributes');
    } catch (e) {
      console.log('Failed to store UTM parameters in cart attributes', e);
    }
  }
  
  // APPROACH 2: Handle checkout forms (add hidden inputs)
  try {
    document.querySelectorAll('form[action*="/cart"][action*="checkout"], form[action*="checkout"]').forEach(function(form) {
      // First check if form already has UTM hidden inputs
      var hasUtmInputs = false;
      form.querySelectorAll('input[name^="checkout[attributes][utm_"]').forEach(function() {
        hasUtmInputs = true;
      });
      
      if (!hasUtmInputs) {
        for (var key in utmParams) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'checkout[attributes][' + key + ']';
          input.value = utmParams[key];
          form.appendChild(input);
        }
        console.log('Added UTM parameters to checkout form');
      }
    });
  } catch (e) {
    console.log('Error adding UTM parameters to checkout form', e);
  }

  // APPROACH 3: Update checkout links with UTM parameters
  try {
    document.querySelectorAll('a[href*="checkout"], [name="checkout"], .checkout-button').forEach(function(link) {
      if (link.tagName === 'A' && link.href && !link.href.includes('utm_') && window.appendUTMParamsToURL) {
        link.href = window.appendUTMParamsToURL(link.href, storedUTMString);
        console.log('Updated checkout link with UTM parameters:', link.href);
      }
    });
    console.log('Updated checkout links with UTM parameters');
  } catch (e) {
    console.log('Error updating checkout links with UTM parameters', e);
  }
  
  // APPROACH 4: Handle Shopify's native checkout buttons
  try {
    document.querySelectorAll('[data-shopify="payment-button"], .shopify-payment-button__button').forEach(function(button) {
      button.addEventListener('click', function(e) {
        // Store UTMs in cart attributes before checkout
        if (window.storeCartAttributes && storedUTMString) {
          window.storeCartAttributes(storedUTMString);
        }
      });
    });
  } catch (e) {
    console.log('Error handling Shopify payment buttons', e);
  }
}

// Function to ensure checkout URL includes UTM parameters
function enhanceCheckoutURL() {
  // Only run if user originally had UTMs
  if (localStorage.getItem('utm_origin_present') !== 'true') return;

  var storedUTMString = window.getStoredUTMString ? window.getStoredUTMString() : null;
  if (!storedUTMString) return;
  
  console.log('Enhancing checkout URL with UTM parameters');
  
  // Handle all checkout links and ensure they include UTM parameters
  try {
    // Find all checkout links and buttons
    var checkoutElements = document.querySelectorAll('a[href*="checkout"], a[href*="/checkouts/"], [name="checkout"], .checkout-button, [data-shopify="payment-button"], .shopify-payment-button__button');
    
    checkoutElements.forEach(function(element) {
      // Handle regular links
      if (element.tagName === 'A' && element.href) {
        if (!element.href.includes('utm_') && window.appendUTMParamsToURL) {
          var enhancedUrl = window.appendUTMParamsToURL(element.href, storedUTMString);
          if (enhancedUrl !== element.href) {
            element.href = enhancedUrl;
            console.log('Enhanced checkout URL:', enhancedUrl);
          }
        }
      }
      
      // Handle buttons that might redirect to checkout
      if (element.tagName !== 'A' || !element.href) {
        if (!element.hasAttribute('data-utm-enhanced')) {
          element.setAttribute('data-utm-enhanced', 'true');
          
          element.addEventListener('click', function(e) {
            // Store UTMs in cart attributes before checkout
            if (window.storeCartAttributes && storedUTMString) {
              window.storeCartAttributes(storedUTMString);
              console.log('Stored UTM parameters before checkout button click');
            }
            
            // For buttons that redirect, try to modify the redirect URL
            setTimeout(function() {
              // Check if we're being redirected to checkout
              if ((window.location.href.includes('checkout') || window.location.href.includes('checkout.shopify.com') || window.location.href.includes('/checkouts/')) && !window.location.href.includes('utm_')) {
                var enhancedCheckoutUrl = window.appendUTMParamsToURL(window.location.href, storedUTMString);
                if (enhancedCheckoutUrl !== window.location.href) {
                  window.history.replaceState({}, '', enhancedCheckoutUrl);
                  console.log('Enhanced checkout URL after redirect:', enhancedCheckoutUrl);
                }
              }
            }, 100);
          });
        }
      }
    });
    
    // Also handle any forms that might redirect to checkout
    document.querySelectorAll('form[action*="checkout"], form[action*="/checkouts/"]').forEach(function(form) {
      if (!form.hasAttribute('data-utm-enhanced')) {
        form.setAttribute('data-utm-enhanced', 'true');
        
        form.addEventListener('submit', function(e) {
          // Store UTMs in cart attributes
          if (window.storeCartAttributes && storedUTMString) {
            window.storeCartAttributes(storedUTMString);
          }
          
          // Try to modify the form action URL if it points to checkout
          if (form.action && (form.action.includes('checkout') || form.action.includes('checkout.shopify.com') || form.action.includes('/checkouts/')) && !form.action.includes('utm_')) {
            var enhancedAction = window.appendUTMParamsToURL(form.action, storedUTMString);
            if (enhancedAction !== form.action) {
              form.action = enhancedAction;
              console.log('Enhanced form action URL:', enhancedAction);
            }
          }
        });
      }
    });
    
    console.log('Enhanced ' + checkoutElements.length + ' checkout elements with UTM parameters');
  } catch (e) {
    console.log('Error enhancing checkout URLs:', e);
  }
}

// Function to directly modify checkout links with UTM parameters
function modifyCheckoutLinks() {
  // Only run if user originally had UTMs
  if (localStorage.getItem('utm_origin_present') !== 'true') return;

  var storedUTMString = window.getStoredUTMString ? window.getStoredUTMString() : null;
  if (!storedUTMString) return;
  
  console.log('Directly modifying checkout links with UTM parameters');
  
  // Directly modify all checkout links
  document.querySelectorAll('a[href*="checkout"], a[href*="/checkouts/"]').forEach(function(link) {
    if (link.href && !link.href.includes('utm_') && window.appendUTMParamsToURL) {
      var enhancedUrl = window.appendUTMParamsToURL(link.href, storedUTMString);
      if (enhancedUrl !== link.href) {
        link.href = enhancedUrl;
        console.log('Directly modified checkout link:', enhancedUrl);
      }
    }
  });
  
  // Also modify any checkout buttons that might have href attributes
  document.querySelectorAll('[name="checkout"], .checkout-button').forEach(function(button) {
    if (button.href && !button.href.includes('utm_') && window.appendUTMParamsToURL) {
      var enhancedUrl = window.appendUTMParamsToURL(button.href, storedUTMString);
      if (enhancedUrl !== button.href) {
        button.href = enhancedUrl;
        console.log('Directly modified checkout button:', enhancedUrl);
      }
    }
  });
}

// Expose analytics display function
window.showConversionAnalytics = showConversionAnalytics;

// Function to intercept and modify checkout URLs aggressively
function interceptCheckoutURLs() {
  // Only run if user originally had UTMs
  if (localStorage.getItem('utm_origin_present') !== 'true') return;

  var storedUTMString = window.getStoredUTMString ? window.getStoredUTMString() : null;
  if (!storedUTMString) return;
  
  console.log('Setting up checkout URL interception');
  
  // First, enhance current URL if we're on checkout
  enhanceCurrentCheckoutURL();
  
  // Intercept window.location changes
  var originalAssign = window.location.assign;
  var originalReplace = window.location.replace;
  var originalHref = Object.getOwnPropertyDescriptor(window.location, 'href');
  
  // Override window.location.assign
  window.location.assign = function(url) {
    if (url && (url.includes('checkout') || url.includes('checkout.shopify.com') || url.includes('/checkouts/')) && !url.includes('utm_') && window.appendUTMParamsToURL) {
      var enhancedUrl = window.appendUTMParamsToURL(url, storedUTMString);
      console.log('Intercepted checkout URL assign:', url, '->', enhancedUrl);
      return originalAssign.call(this, enhancedUrl);
    }
    return originalAssign.call(this, url);
  };
  
  // Override window.location.replace
  window.location.replace = function(url) {
    if (url && (url.includes('checkout') || url.includes('checkout.shopify.com') || url.includes('/checkouts/')) && !url.includes('utm_') && window.appendUTMParamsToURL) {
      var enhancedUrl = window.appendUTMParamsToURL(url, storedUTMString);
      console.log('Intercepted checkout URL replace:', url, '->', enhancedUrl);
      return originalReplace.call(this, enhancedUrl);
    }
    return originalReplace.call(this, url);
  };
  
  // Override window.location.href setter
  if (originalHref && originalHref.set) {
    try {
      // Check if the property is configurable before trying to redefine it
      var currentDescriptor = Object.getOwnPropertyDescriptor(window.location, 'href');
      if (currentDescriptor && currentDescriptor.configurable) {
        Object.defineProperty(window.location, 'href', {
          set: function(url) {
            if (url && (url.includes('checkout') || url.includes('checkout.shopify.com') || url.includes('/checkouts/')) && !url.includes('utm_') && window.appendUTMParamsToURL) {
              var enhancedUrl = window.appendUTMParamsToURL(url, storedUTMString);
              console.log('Intercepted checkout URL href set:', url, '->', enhancedUrl);
              return originalHref.set.call(this, enhancedUrl);
            }
            return originalHref.set.call(this, url);
          },
          get: originalHref.get
        });
      } else {
        console.log('window.location.href is not configurable, skipping href override');
      }
    } catch (e) {
      console.log('Could not override window.location.href:', e.message);
    }
  }
  
  // Intercept form submissions that might redirect to checkout
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (form.action && (form.action.includes('checkout') || form.action.includes('checkout.shopify.com') || form.action.includes('/checkouts/')) && !form.action.includes('utm_') && window.appendUTMParamsToURL) {
      var enhancedAction = window.appendUTMParamsToURL(form.action, storedUTMString);
      if (enhancedAction !== form.action) {
        form.action = enhancedAction;
        console.log('Intercepted form submission to checkout:', enhancedAction);
      }
    }
  });
  
  // Intercept clicks on checkout elements
  document.addEventListener('click', function(e) {
    var target = e.target;
    
    // Handle links
    if (target.tagName === 'A' && target.href && (target.href.includes('checkout') || target.href.includes('checkout.shopify.com') || target.href.includes('/checkouts/')) && !target.href.includes('utm_') && window.appendUTMParamsToURL) {
      var enhancedUrl = window.appendUTMParamsToURL(target.href, storedUTMString);
      if (enhancedUrl !== target.href) {
        target.href = enhancedUrl;
        console.log('Intercepted checkout link click:', enhancedUrl);
      }
    }
    
    // Handle buttons that might redirect
    if ((target.matches('[name="checkout"]') || target.matches('.checkout-button') || 
         target.matches('[data-shopify="payment-button"]') || target.matches('.shopify-payment-button__button')) &&
        !target.hasAttribute('data-utm-intercepted')) {
      
      target.setAttribute('data-utm-intercepted', 'true');
      
      // Store UTMs in cart attributes
      if (window.storeCartAttributes && storedUTMString) {
        window.storeCartAttributes(storedUTMString);
      }
      
      // Monitor for URL changes after click
      var originalHref = window.location.href;
      setTimeout(function() {
        if (window.location.href !== originalHref && (window.location.href.includes('checkout') || window.location.href.includes('checkout.shopify.com') || window.location.href.includes('/checkouts/')) && !window.location.href.includes('utm_')) {
          var enhancedUrl = window.appendUTMParamsToURL(window.location.href, storedUTMString);
          if (enhancedUrl !== window.location.href) {
            window.history.replaceState({}, '', enhancedUrl);
            console.log('Intercepted checkout redirect:', enhancedUrl);
          }
        }
      }, 100);
    }
  });
  
  // Enhanced approach: Modify all checkout links immediately
  setTimeout(function() {
    document.querySelectorAll('a[href*="checkout"], a[href*="/checkouts/"]').forEach(function(link) {
      if (link.href && !link.href.includes('utm_') && window.appendUTMParamsToURL) {
        var enhancedUrl = window.appendUTMParamsToURL(link.href, storedUTMString);
        if (enhancedUrl !== link.href) {
          link.href = enhancedUrl;
          console.log('Enhanced checkout link:', enhancedUrl);
        }
      }
    });
  }, 500);
  
  console.log('Checkout URL interception set up');
}

// Function to handle current checkout URL if already on checkout page
function enhanceCurrentCheckoutURL() {
  console.log('=== ENHANCE CURRENT CHECKOUT URL ===');
  
  // Only run if user originally had UTMs
  if (localStorage.getItem('utm_origin_present') !== 'true') {
    console.log('❌ User did not arrive with UTMs - skipping');
    return;
  }

  var storedUTMString = window.getStoredUTMString ? window.getStoredUTMString() : null;
  if (!storedUTMString) {
    console.log('❌ No stored UTM string found');
    return;
  }
  
  console.log('Stored UTM String:', storedUTMString);
  console.log('Current URL:', window.location.href);
  
  // Check if we're currently on a checkout page
  var isCheckoutPage = (window.location.href.includes('checkout') || 
                        window.location.href.includes('checkout.shopify.com') || 
                        window.location.href.includes('/checkouts/'));
  console.log('Is checkout page:', isCheckoutPage);
  
  var hasUTMs = window.location.href.includes('utm_');
  console.log('URL already has UTMs:', hasUTMs);
  
  if (isCheckoutPage && !hasUTMs && window.appendUTMParamsToURL) {
    var enhancedUrl = window.appendUTMParamsToURL(window.location.href, storedUTMString);
    console.log('Enhanced URL:', enhancedUrl);
    
    if (enhancedUrl !== window.location.href) {
      try {
        window.history.replaceState({}, '', enhancedUrl);
        console.log('✅ Successfully enhanced current checkout URL:', enhancedUrl);
        console.log('New URL:', window.location.href);
      } catch (e) {
        console.log('❌ Failed to update URL:', e.message);
      }
    } else {
      console.log('⚠️ Enhanced URL is same as current URL');
    }
  } else {
    console.log('❌ Cannot enhance URL - conditions not met');
    console.log('- Is checkout page:', isCheckoutPage);
    console.log('- Has UTMs:', hasUTMs);
    console.log('- appendUTMParamsToURL function:', !!window.appendUTMParamsToURL);
  }
  
  console.log('=== END ENHANCE CURRENT CHECKOUT URL ===');
}

// Function to handle Shopify's checkout domain redirects
function handleShopifyCheckoutRedirect() {
  // Only run if user originally had UTMs
  if (localStorage.getItem('utm_origin_present') !== 'true') return;

  var storedUTMString = window.getStoredUTMString ? window.getStoredUTMString() : null;
  if (!storedUTMString) return;
  
  console.log('Setting up Shopify checkout redirect handling');
  
  // Monitor for navigation to Shopify checkout domain
  var originalPushState = history.pushState;
  var originalReplaceState = history.replaceState;
  
  history.pushState = function() {
    var url = arguments[2];
    if (url && (url.includes('checkout.shopify.com') || url.includes('checkout') || url.includes('/checkouts/')) && !url.includes('utm_') && window.appendUTMParamsToURL) {
      var enhancedUrl = window.appendUTMParamsToURL(url, storedUTMString);
      console.log('Intercepted pushState to checkout:', url, '->', enhancedUrl);
      arguments[2] = enhancedUrl;
    }
    return originalPushState.apply(this, arguments);
  };
  
  history.replaceState = function() {
    var url = arguments[2];
    if (url && (url.includes('checkout.shopify.com') || url.includes('checkout') || url.includes('/checkouts/')) && !url.includes('utm_') && window.appendUTMParamsToURL) {
      var enhancedUrl = window.appendUTMParamsToURL(url, storedUTMString);
      console.log('Intercepted replaceState to checkout:', url, '->', enhancedUrl);
      arguments[2] = enhancedUrl;
    }
    return originalReplaceState.apply(this, arguments);
  };
  
  // Monitor for actual page navigation
  window.addEventListener('beforeunload', function() {
    if ((window.location.href.includes('checkout') || window.location.href.includes('/checkouts/')) && !window.location.href.includes('utm_')) {
      // Store UTM parameters in sessionStorage for the next page
      sessionStorage.setItem('pending_utm_params', storedUTMString);
      console.log('Stored UTM parameters for next page navigation');
    }
  });
  
  // Check if we have pending UTM parameters from previous page
  var pendingUtmParams = sessionStorage.getItem('pending_utm_params');
  if (pendingUtmParams && (window.location.href.includes('checkout') || window.location.href.includes('/checkouts/')) && !window.location.href.includes('utm_')) {
    var enhancedUrl = window.appendUTMParamsToURL(window.location.href, pendingUtmParams);
    if (enhancedUrl !== window.location.href) {
      window.history.replaceState({}, '', enhancedUrl);
      console.log('Applied pending UTM parameters to checkout URL:', enhancedUrl);
    }
    sessionStorage.removeItem('pending_utm_params');
  }
  
  console.log('Shopify checkout redirect handling set up');
}

// Call on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
  // Check if URL has UTMs - ONLY process if UTMs are in the current page URL
  var currentUrl = window.location.href;
  var hasUtmsInUrl = currentUrl.indexOf('utm_source=') !== -1 || 
                    currentUrl.indexOf('utm_medium=') !== -1 || 
                    currentUrl.indexOf('utm_campaign=') !== -1;
                    
  if (!hasUtmsInUrl) {
    console.log('No UTM parameters in current URL - not processing UTMs');
    return;
  }
  
  console.log('UTM parameters detected in URL - processing ONE TIME ONLY');
  
  // Extract UTM parameters from URL
  var urlParams = getUTMParamsFromURL(window.location.href);
  if (!urlParams || Object.keys(urlParams).length === 0) return;
  
  // Create UTM string for appending to links
  var utmString = '';
  for (var key in urlParams) {
    utmString += (utmString ? '&' : '') + key + '=' + encodeURIComponent(urlParams[key]);
  }
  
  // Store UTM parameters
  storeUTMParams(urlParams);
  
  // Mark that this user arrived via a campaign
  localStorage.setItem('utm_origin_present', 'true');
  
  // Add UTM parameters to internal links
  console.log('Adding UTM parameters to internal links');
  updateLinksWithUTM(utmString);
  
  // Store UTM parameters as cart attributes for checkout
  if (window.storeCartAttributes && typeof window.storeCartAttributes === 'function') {
    storeCartAttributes(utmString);
  }
  
  // Set up analytics with UTM parameters
  setupAnalyticsWithUTMs();
  
  // Enhanced checkout handling
  setTimeout(function() {
    enhanceCheckoutWithUTMs();
  }, 1000);
  
  // Handle Shopify's native checkout process
  setTimeout(function() {
    handleShopifyCheckout();
  }, 1500);
  
  // Enhance checkout URLs with UTM parameters
  setTimeout(function() {
    enhanceCheckoutURL();
  }, 2000);
  
  // Set up aggressive checkout URL interception
  setTimeout(function() {
    interceptCheckoutURLs();
  }, 2500);
  
  // Handle Shopify checkout redirects
  setTimeout(function() {
    handleShopifyCheckoutRedirect();
  }, 3000);
  
  // IMPORTANT: Check if we're already on a checkout page and enhance the URL
  setTimeout(function() {
    enhanceCurrentCheckoutURL();
  }, 500);
});

// Function to test UTM parameter addition to checkout URL
function testUTMCheckoutURL() {
  console.log('=== UTM CHECKOUT URL TEST ===');
  
  // Check if we have stored UTM parameters
  var storedUTMString = window.getStoredUTMString ? window.getStoredUTMString() : null;
  console.log('Stored UTM String:', storedUTMString);
  
  // Check if we're on a checkout page
  var isCheckoutPage = window.location.href.includes('checkout') || 
                       window.location.href.includes('checkout.shopify.com') || 
                       window.location.href.includes('/checkouts/');
  console.log('Is checkout page:', isCheckoutPage);
  console.log('Current URL:', window.location.href);
  
  // Check if URL already has UTM parameters
  var hasUTMs = window.location.href.includes('utm_');
  console.log('URL already has UTMs:', hasUTMs);
  
  // Test enhancing the URL
  if (storedUTMString && isCheckoutPage && !hasUTMs && window.appendUTMParamsToURL) {
    var enhancedUrl = window.appendUTMParamsToURL(window.location.href, storedUTMString);
    console.log('Enhanced URL:', enhancedUrl);
    
    // Try to update the URL
    try {
      window.history.replaceState({}, '', enhancedUrl);
      console.log('✅ Successfully updated checkout URL with UTM parameters');
      console.log('New URL:', window.location.href);
    } catch (e) {
      console.log('❌ Failed to update URL:', e.message);
    }
  } else {
    console.log('❌ Cannot enhance URL - missing requirements');
  }
  
  console.log('=== END TEST ===');
}

// Expose test function globally
window.testUTMCheckoutURL = testUTMCheckoutURL;

